import React, { useState, useEffect, useCallback, useRef } from "react";

const API = "";

// ── Auth: токен ко всем /api-запросам ────────────────────────────────────────
const _fetch = window.fetch.bind(window);
window.fetch = (url, opts = {}) => {
  const t = localStorage.getItem("token");
  const sid = localStorage.getItem("storeId");
  if (typeof url === "string" && url.startsWith("/api") && t) {
    const h = { ...(opts.headers || {}), Authorization: "Bearer " + t };
    if (sid) h["X-Store-Id"] = sid;  // магазин, выбранный в переключателе
    opts = { ...opts, headers: h };
  }
  return _fetch(url, opts).then(r => {
    if (r.status === 403 && typeof url === "string" && url.startsWith("/api")) {
      // заблокированный пользователь — выход на страницу входа
      r.clone().json().then(d => {
        if (d && d.detail === "Доступ заблокирован") {
          localStorage.removeItem("token"); localStorage.removeItem("storeId");
          window.dispatchEvent(new CustomEvent("ozon:logout"));
        }
      }).catch(() => {});
    }
    if (r.status === 401 && !url.includes("/api/auth/")) {
      localStorage.removeItem("token");
      localStorage.removeItem("storeId");
      // Диспатчим событие вместо reload() — чтобы не было бесконечного цикла
      window.dispatchEvent(new CustomEvent("ozon:logout"));
    }
    return r;
  });
};

const P = {
  bg: "#0a0e1a", surface: "#111827", card: "#161d2e", border: "#1e2a3a",
  accent: "#005bff", accentSoft: "#1a3a6e", teal: "#00c2a8", tealSoft: "#003d35",
  red: "#ff4d6a", redSoft: "#3d0f1a", yellow: "#f5c518", yellowSoft: "#3d3005",
  text: "#e8edf5", muted: "#6b7a99", dim: "#3a4560",
};

const css = `
.grid{display:grid;gap:12px}
.grid-4{grid-template-columns:repeat(4,minmax(0,1fr))}
@media(max-width:900px){.grid-4{grid-template-columns:repeat(2,minmax(0,1fr))}}
.card{background:${P.card};border:1px solid ${P.border};border-radius:12px}
@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;700&family=Manrope:wght@400;500;600;700;800&display=swap');
*{box-sizing:border-box;margin:0;padding:0}
body{background:${P.bg};color:${P.text};font-family:'Manrope',sans-serif;min-height:100vh}
::-webkit-scrollbar{width:6px;height:6px}
::-webkit-scrollbar-track{background:${P.surface}}
::-webkit-scrollbar-thumb{background:${P.dim};border-radius:3px}
.mono{font-family:'JetBrains Mono',monospace}
.app{display:flex;flex-direction:column;min-height:100vh}
.header{background:${P.surface};border-bottom:1px solid ${P.border};padding:0 24px;display:flex;align-items:center;gap:12px;height:58px;position:sticky;top:0;z-index:100}
.header-logo{font-size:17px;font-weight:800;letter-spacing:-0.5px;display:flex;align-items:center;gap:6px}
.header-logo span{color:${P.accent}}
.header-badge{background:${P.accentSoft};color:${P.accent};font-size:10px;font-weight:700;padding:2px 8px;border-radius:99px;text-transform:uppercase;letter-spacing:1px}
.store-selector{background:${P.card};border:1px solid ${P.border};color:${P.text};border-radius:8px;padding:5px 10px;font-size:12px;font-family:'Manrope',sans-serif;outline:none;cursor:pointer}
.header-spacer{flex:1}
.header-time{font-size:11px;color:${P.muted};display:flex;align-items:center;gap:6px}
.sync-dot{width:7px;height:7px;border-radius:50%;background:${P.teal};box-shadow:0 0 6px ${P.teal};animation:pulse 2s infinite}
@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}
.nav{background:${P.surface};border-bottom:1px solid ${P.border};padding:0 24px;display:flex;gap:2px;overflow-x:auto}
.nav-tab{padding:10px 14px;font-size:13px;font-weight:600;color:${P.muted};cursor:pointer;border:none;background:none;border-bottom:2px solid transparent;transition:all 0.15s;display:flex;align-items:center;gap:5px;white-space:nowrap}
.nav-tab:hover{color:${P.text}}
.nav-tab.active{color:${P.accent};border-bottom-color:${P.accent}}
.main{padding:20px 24px;flex:1;max-width:1600px;width:100%;margin:0 auto}
.kpi-row{display:grid;grid-template-columns:repeat(5,1fr);gap:10px;margin-bottom:20px}
@media(max-width:1100px){.kpi-row{grid-template-columns:repeat(3,1fr)}}
@media(max-width:700px){.kpi-row{grid-template-columns:repeat(2,1fr)}}
.kpi-card{background:${P.card};border:1px solid ${P.border};border-radius:10px;padding:16px 18px;display:flex;flex-direction:column;gap:5px;position:relative;overflow:hidden;transition:border-color 0.2s,transform 0.15s;cursor:pointer}
.kpi-card:hover{border-color:${P.dim};transform:translateY(-1px)}
.kpi-card::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:var(--kc,${P.accent})}
.kpi-label{font-size:10px;color:${P.muted};text-transform:uppercase;letter-spacing:0.8px;font-weight:700}
.kpi-value{font-size:24px;font-weight:800;line-height:1;font-family:'JetBrains Mono',monospace}
.kpi-sub{font-size:11px;color:${P.muted}}
.kpi-change{font-size:10px;font-weight:700;padding:2px 5px;border-radius:3px;display:inline-flex;align-items:center;gap:2px;width:fit-content;margin-top:2px}
.kpi-change.up{background:${P.tealSoft};color:${P.teal}}
.kpi-change.dn{background:${P.redSoft};color:${P.red}}
.sec-hdr{display:flex;align-items:center;gap:10px;margin-bottom:14px;flex-wrap:wrap}
.sec-title{font-size:14px;font-weight:700}
.sec-badge{background:${P.border};color:${P.muted};font-size:10px;font-weight:700;padding:2px 7px;border-radius:99px;font-family:'JetBrains Mono',monospace}
.tw{background:${P.card};border:1px solid ${P.border};border-radius:10px;overflow-x:auto;-webkit-overflow-scrolling:touch}
table{width:100%;border-collapse:collapse}
thead th{background:${P.surface};padding:9px 12px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.8px;color:${P.muted};text-align:left;border-bottom:1px solid ${P.border};white-space:nowrap}
thead th.r{text-align:right}
tbody tr{border-bottom:1px solid ${P.border};transition:background 0.1s;cursor:pointer}
tbody tr:last-child{border-bottom:none}
tbody tr:hover{background:${P.surface}}
td{padding:10px 12px;font-size:13px;vertical-align:middle}
td.r{text-align:right;font-family:'JetBrains Mono',monospace;font-size:12px}
td.mu{color:${P.muted};font-size:11px}
.pname{font-weight:600;font-size:13px;max-width:280px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pid{font-size:10px;color:${P.muted};font-family:'JetBrains Mono',monospace}
.chip{font-size:11px;font-weight:700;font-family:'JetBrains Mono',monospace;padding:2px 6px;border-radius:4px}
.chip.fbo{background:${P.accentSoft};color:${P.accent}}
.chip.fbs{background:${P.yellowSoft};color:${P.yellow}}
.chip.zero{background:${P.redSoft};color:${P.red}}
.chip.rsv{background:${P.tealSoft};color:${P.teal}}
.chip.warn{background:${P.yellowSoft};color:${P.yellow}}
.bar-w{display:flex;align-items:center;gap:6px}
.bar{height:4px;border-radius:2px;flex:1;background:${P.border};overflow:hidden;min-width:50px}
.bar-f{height:100%;border-radius:2px;background:var(--bc,${P.teal})}
.toolbar{display:flex;gap:8px;margin-bottom:14px;align-items:center;flex-wrap:wrap}
.si{background:${P.card};border:1px solid ${P.border};color:${P.text};border-radius:8px;padding:7px 11px;font-size:13px;font-family:'Manrope',sans-serif;outline:none;width:240px;transition:border-color 0.15s}
.si:focus{border-color:${P.accent}}
.si::placeholder{color:${P.dim}}
.btn{padding:7px 13px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer;border:none;transition:all 0.15s;font-family:'Manrope',sans-serif;display:flex;align-items:center;gap:5px}
.btn-p{background:${P.accent};color:#fff}
.btn-p:hover{background:#1a6aff}
.btn-g{background:${P.card};color:${P.muted};border:1px solid ${P.border}}
.btn-g:hover{color:${P.text};border-color:${P.dim}}
.btn-d{background:${P.redSoft};color:${P.red};border:1px solid ${P.redSoft}}
.btn:disabled{opacity:0.4;cursor:not-allowed}
.pills{display:flex;gap:3px;background:${P.card};border:1px solid ${P.border};border-radius:8px;padding:3px;flex-wrap:wrap}
.pill{padding:4px 11px;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;border:none;background:none;color:${P.muted};transition:all 0.15s}
.pill.active{background:${P.accentSoft};color:${P.accent}}
.sth{cursor:pointer;user-select:none}
.sth:hover{color:${P.text}}
.sth.sd{color:${P.accent}}
.empty{padding:50px 20px;text-align:center;color:${P.muted};font-size:13px}
.m-only{display:none}
.ord-head{display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;margin:0 0 8px;color:${P.muted};font-size:13px;font-weight:600}
.ord-name{max-width:420px;white-space:normal;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.ord-total td{border-top:2px solid ${P.border};background:${P.surface}}
.ord-cards{display:none;flex-direction:column;gap:8px}
.ord-card{background:${P.card};border:1px solid ${P.border};border-radius:10px;padding:10px 12px}
.ord-card.ord-total{background:${P.surface}}
.ord-top{display:flex;justify-content:space-between;gap:10px;align-items:flex-start}
.ord-stats{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:6px;margin-top:8px;font-size:12px;font-family:'JetBrains Mono',monospace}
.ord-stats span{display:block;font-family:inherit;color:${P.dim};font-size:10px;text-transform:uppercase;letter-spacing:.03em}
@media(max-width:380px){.ord-stats{grid-template-columns:repeat(2,minmax(0,1fr))}}
.spin{width:22px;height:22px;border:2px solid ${P.border};border-top-color:${P.accent};border-radius:50%;animation:spin 0.7s linear infinite;margin:0 auto 10px}
@keyframes spin{to{transform:rotate(360deg)}}
.alert{padding:10px 14px;border-radius:8px;font-size:12px;margin-bottom:14px;border-left:3px solid}
.alert-e{background:${P.redSoft};border-color:${P.red};color:#ffb3bf}
.alert-ok{background:${P.tealSoft};border-color:${P.teal};color:#7ffff0}
.dash-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:20px}
@media(max-width:900px){.dash-grid{grid-template-columns:1fr}}
.chart-box{background:${P.card};border:1px solid ${P.border};border-radius:10px;padding:18px;margin-bottom:18px}
.chart-area{height:160px;margin-top:12px}

/* Modal */
.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:200;display:flex;align-items:center;justify-content:center;padding:20px}
.modal{background:${P.surface};border:1px solid ${P.border};border-radius:14px;width:100%;max-width:900px;max-height:90vh;overflow-y:auto;padding:24px}
.modal-hdr{display:flex;align-items:flex-start;gap:12px;margin-bottom:20px}
.modal-title{font-size:16px;font-weight:800;flex:1}
.modal-close{background:${P.card};border:1px solid ${P.border};color:${P.muted};border-radius:8px;padding:6px 10px;cursor:pointer;font-size:14px}
.modal-close:hover{color:${P.text}}
.modal-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:18px}
@media(max-width:700px){.modal-grid{grid-template-columns:1fr}}
.modal-card{background:${P.card};border:1px solid ${P.border};border-radius:10px;padding:16px}
.modal-card-title{font-size:11px;font-weight:700;color:${P.muted};text-transform:uppercase;letter-spacing:0.8px;margin-bottom:12px}

/* Settings */
.sg{display:grid;grid-template-columns:1fr 1fr;gap:14px}
@media(max-width:768px){.sg{grid-template-columns:1fr}}
.sc{background:${P.card};border:1px solid ${P.border};border-radius:10px;padding:18px}
.slabel{font-size:11px;font-weight:700;color:${P.muted};text-transform:uppercase;letter-spacing:0.8px;margin-bottom:5px}
.sinput{width:100%;background:${P.surface};border:1px solid ${P.border};color:${P.text};border-radius:8px;padding:8px 11px;font-size:13px;font-family:'JetBrains Mono',monospace;outline:none;transition:border-color 0.15s}
.sinput:focus{border-color:${P.accent}}
.store-card{background:${P.card};border:1px solid ${P.border};border-radius:10px;padding:16px;display:flex;align-items:center;gap:12px;margin-bottom:10px}
.store-dot{width:8px;height:8px;border-radius:50%;background:${P.dim}}
.store-dot.active{background:${P.teal};box-shadow:0 0 6px ${P.teal}}
.store-name{font-weight:700;font-size:14px;flex:1}
.store-id{font-size:11px;color:${P.muted};font-family:'JetBrains Mono',monospace}
.sync-log{background:${P.surface};border:1px solid ${P.border};border-radius:8px;padding:10px 12px;font-family:'JetBrains Mono',monospace;font-size:11px;color:${P.muted};max-height:160px;overflow-y:auto;line-height:1.8;margin-top:12px}
.sl-ok{color:${P.teal}}
.sl-err{color:${P.red}}

/* Revenue pct bar */
.rev-pct{display:flex;align-items:center;gap:6px;margin-top:3px}
.rev-pct-bar{height:3px;border-radius:2px;background:${P.accent};min-width:2px}
.rev-pct-label{font-size:10px;color:${P.muted};font-family:'JetBrains Mono',monospace}

/* Finance P&L waterfall */
.pl-row{display:flex;align-items:center;gap:10px;margin-bottom:8px}
.pl-label{width:130px;font-size:12px;text-align:right;flex-shrink:0}
.pl-bar-track{flex:1;background:${P.border};border-radius:4px;height:22px;overflow:hidden;position:relative}
.pl-bar-fill{height:100%;border-radius:4px;transition:width 0.4s ease}
.pl-amount{width:130px;font-size:12px;font-family:'JetBrains Mono',monospace;text-align:right;flex-shrink:0}
.net-profit-box{border-radius:10px;padding:16px 20px;margin-bottom:20px;display:flex;align-items:center;gap:28px;flex-wrap:wrap}

/* ── Телефон ── */
@media(max-width:700px){
  body{-webkit-text-size-adjust:100%}
  .header{padding:0 12px;gap:8px;height:52px}
  .header-logo{font-size:15px}
  .store-selector{max-width:46vw;font-size:13px;padding:6px 8px}
  .m-hide{display:none!important}
  .nav{padding:0 6px;scrollbar-width:none;position:sticky;top:52px;z-index:99}
  .nav::-webkit-scrollbar{display:none}
  .nav-tab{padding:12px 11px;font-size:13px}
  .main{padding:12px 10px}
  .kpi-row,.m-kpi{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:8px;margin-bottom:14px}
  .kpi-card{padding:12px;gap:4px}
  .kpi-card:hover{transform:none}
  .kpi-value{font-size:18px;word-break:break-word}
  .kpi-sub{font-size:10px}
  .m-stack,.dash-grid,.modal-grid,.sg{grid-template-columns:1fr!important}
  .grid-4{grid-template-columns:repeat(2,minmax(0,1fr))}
  .toolbar{gap:6px}
  .si{width:auto;flex:1 1 180px;min-width:0;font-size:16px}
  .nav-tab:hover{color:${P.muted}}
  .nav-tab.active:hover{color:${P.accent}}
  .sinput,select,input,textarea{font-size:16px}
  .btn{padding:9px 12px}
  .pills{overflow-x:auto;flex-wrap:nowrap;max-width:100%;scrollbar-width:none}
  .pills::-webkit-scrollbar{display:none}
  .pill{padding:7px 11px;white-space:nowrap}
  thead th{padding:8px;font-size:9px}
  td{padding:8px;font-size:12px}
  td.r{font-size:11px;white-space:nowrap}
  .pname{max-width:150px}
  .tw table tr>*:first-child{position:sticky;left:0;z-index:1;background:${P.card}}
  .tw thead tr>*:first-child{background:${P.surface};z-index:2}
  .chart-box{padding:12px}
  .modal-overlay{padding:0;align-items:stretch}
  .modal{max-height:100vh;height:100%;border-radius:0;padding:14px;max-width:none}
  .modal-close{padding:10px 14px}
  .pl-label{width:96px;font-size:11px}
  .pl-amount{width:84px;font-size:11px}
  .net-profit-box{gap:14px;padding:12px}
  .store-card{flex-wrap:wrap}
  .empty{padding:30px 12px}
  .m-only{display:block}
  .ord-cards.m-only{display:flex}
  .ord-name{max-width:none;font-size:13px}
}
`;

const fmt = {
  num: (v, d=0) => (v??0).toLocaleString("ru-RU",{maximumFractionDigits:d}),
  rub: v => `${fmt.num(v,0)} ₽`,
  pct: v => `${(v??0).toFixed(1)}%`,
  short: v => v>=1e6?`${(v/1e6).toFixed(1)}M`:v>=1e3?`${(v/1e3).toFixed(1)}K`:String(v??0),
};

function useFetch(url, deps=[]) {
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState(null);
  const load=useCallback(async()=>{
    setLoading(true);setError(null);
    try{
      const r=await fetch(API+url);
      if(!r.ok){
        let msg=`HTTP ${r.status}`;
        try{const d=await r.json().catch(()=>({detail:`HTTP ${r.status}`}));msg=d.message||d.detail||msg;}catch(_){}
        throw new Error(msg);
      }
      setData(await r.json());
    }
    catch(e){setError(e.message);setData(null);}   // при ошибке не показываем цифры прошлого периода
    finally{setLoading(false);}
  },[url,...deps]);
  useEffect(()=>{load();},[load]);
  return {data,loading,error,reload:load};
}

function useProductNames(ids=[]) {
  const [names,setNames]=useState({});
  useEffect(()=>{
    if(!ids.length)return;
    const unique=[...new Set(ids)].filter(Boolean).slice(0,100);
    fetch(API+"/api/products/info",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({product_ids:unique.map(Number)})})
      .then(r=>r.json()).then(d=>{
        const m={};
        (d.items||d||[]).forEach(p=>{m[p.id]={name:p.name,price:p.price,images:p.images};});
        setNames(m);
      }).catch(()=>{});
  },[ids.join(",")]);
  return names;
}

function Spin(){return <div className="empty"><div className="spin"/><div>Загрузка...</div></div>;}

function KpiCard({label,value,sub,change,color=P.accent,onClick}){
  const up=change>0;
  return(
    <div className="kpi-card" style={{"--kc":color}} onClick={onClick}>
      <div className="kpi-label">{label}</div>
      <div className="kpi-value" style={{color}}>{value}</div>
      {sub&&<div className="kpi-sub">{sub}</div>}
      {change!==undefined&&<div className={`kpi-change ${up?"up":"dn"}`}>{up?"▲":"▼"} {Math.abs(change).toFixed(1)}%</div>}
    </div>
  );
}

// ── Product Detail Modal ────────────────────────────────────────────────────
function ProductModal({product,onClose,allAnalytics=[],allStocks=[]}){
  const id=product.product_id||product.id||product._id;
  const name=product.name||product.offer_id||String(id);
  const stock=allStocks.find(s=>s.product_id===id||(product.sku&&String(s.sku)===String(product.sku)))||{};
  // Аналитика Ozon — по SKU (не product_id): берём SKU товара или его остатка
  const sku=String(product.sku||stock.sku||"");
  const rows=allAnalytics.filter(r=>sku?String(r.sku)===sku:String(r.sku||r.product_id)===String(id));
  const totalRev=rows.reduce((s,r)=>s+(r.revenue||0),0);
  const totalOrders=rows.reduce((s,r)=>s+(r.ordered_units||0),0);
  const totalSessions=rows.reduce((s,r)=>s+(r.sessions||0),0);
  const conv=totalSessions?(totalOrders/totalSessions*100):0;
  const nDays=new Set(rows.map(r=>r.date)).size||1;
  const unitsPerDay=totalOrders/nDays;                       // продажи в штуках в день
  const fboStock=stock.fbo_present||0;
  const daysLeft=unitsPerDay>0?(fboStock/unitsPerDay):null;   // остаток (шт.) / шт. в день

  return(
    <div className="modal-overlay" onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div className="modal">
        <div className="modal-hdr">
          <div>
            <div className="modal-title">{name}</div>
            <div className="pid">ID: {id} · {product.offer_id}</div>
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-grid">
          <div className="modal-card">
            <div className="modal-card-title">Продажи за период</div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <div><div style={{fontSize:11,color:P.muted}}>Выручка</div><div style={{fontSize:20,fontWeight:800,fontFamily:"JetBrains Mono",color:P.accent}}>{fmt.rub(totalRev)}</div></div>
              <div style={{display:"flex",gap:20}}>
                <div><div style={{fontSize:11,color:P.muted}}>Заказы</div><div style={{fontSize:16,fontWeight:700,fontFamily:"JetBrains Mono"}}>{fmt.num(totalOrders)}</div></div>
                <div><div style={{fontSize:11,color:P.muted}}>Сессии</div><div style={{fontSize:16,fontWeight:700,fontFamily:"JetBrains Mono"}}>{fmt.short(totalSessions)}</div></div>
                <div><div style={{fontSize:11,color:P.muted}}>Конверсия</div><div style={{fontSize:16,fontWeight:700,fontFamily:"JetBrains Mono",color:conv>3?P.teal:conv>1?P.yellow:P.red}}>{fmt.pct(conv)}</div></div>
              </div>
            </div>
          </div>

          <div className="modal-card">
            <div className="modal-card-title">Остатки</div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <div style={{display:"flex",gap:20}}>
                <div><div style={{fontSize:11,color:P.muted}}>FBO</div><div style={{fontSize:20,fontWeight:800,fontFamily:"JetBrains Mono",color:fboStock<10?P.red:P.accent}}>{fboStock}</div></div>
                <div><div style={{fontSize:11,color:P.muted}}>FBS</div><div style={{fontSize:20,fontWeight:800,fontFamily:"JetBrains Mono",color:P.yellow}}>{stock.fbs_present||0}</div></div>
                <div><div style={{fontSize:11,color:P.muted}}>Резерв FBO</div><div style={{fontSize:16,fontWeight:700,fontFamily:"JetBrains Mono",color:P.teal}}>{stock.fbo_reserved||0}</div></div>
              </div>
              {daysLeft!==null&&(
                <div style={{padding:"8px 12px",background:daysLeft<7?P.redSoft:daysLeft<14?P.yellowSoft:P.tealSoft,borderRadius:8,fontSize:12}}>
                  <span style={{color:daysLeft<7?P.red:daysLeft<14?P.yellow:P.teal,fontWeight:700}}>
                    {daysLeft<1?"⚠ Сток заканчивается сегодня":`≈ ${Math.round(daysLeft)} дней до нуля`}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {rows.length>0&&(
          <div className="modal-card" style={{marginBottom:14}}>
            <div className="modal-card-title">Динамика выручки по дням</div>
            <div style={{height:100,marginTop:10}}>
              <svg width="100%" height="100%" viewBox={`0 0 ${rows.length*24} 80`} preserveAspectRatio="none">
                {rows.map((r,i)=>{
                  const h=Math.max(3,(r.revenue||0)/Math.max(...rows.map(x=>x.revenue||0),1)*70);
                  return <rect key={i} x={i*24+2} y={80-h} width={20} height={h} rx="2"
                    fill={i===rows.length-1?P.accent:P.accentSoft}/>;
                })}
              </svg>
            </div>
          </div>
        )}

        <div className="tw">
          <table>
            <thead><tr>
              <th>Дата</th><th className="r">Выручка</th><th className="r">Заказы</th><th className="r">Сессии</th><th className="r">Конв.</th>
            </tr></thead>
            <tbody>
              {rows.slice(-14).reverse().map((r,i)=>{
                const c=r.sessions?(r.ordered_units||0)/r.sessions*100:0;
                return <tr key={i}>
                  <td className="mu">{r.date}</td>
                  <td className="r">{fmt.rub(r.revenue)}</td>
                  <td className="r">{r.ordered_units||0}</td>
                  <td className="r">{fmt.short(r.sessions)}</td>
                  <td className="r" style={{color:c>3?P.teal:c>1?P.yellow:P.red}}>{fmt.pct(c)}</td>
                </tr>;
              })}
              {!rows.length&&<tr><td colSpan={5}><div className="empty">Нет аналитики</div></td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ── Finance / P&L ────────────────────────────────────────────────────────────
function Finance() {
  const [period, setPeriod] = useState(30);
  const [syncing, setSyncing] = useState(false);
  const [syncMsg, setSyncMsg] = useState('');
  const [catFilter, setCatFilter] = useState('');

  const {data: summary, loading: sl, error: se, reload: reloadS} = useFetch(`/api/finance/summary?days=${period}`, [period]);
  const {data: byDay, loading: dl} = useFetch(`/api/finance/by-day?days=${period}`, [period]);
  const {data: txData, loading: tl, reload: reloadT} = useFetch(
    `/api/finance/transactions?days=${period}&limit=50${catFilter ? '&category='+catFilter : ''}`,
    [period, catFilter]
  );

  const syncNow = async () => {
    setSyncing(true);
    setSyncMsg('⟳ Загружаю данные...');
    try {
      const r = await fetch(API + `/api/finance/sync?days=${period}`, {method: 'POST'});
      const d = await r.json().catch(()=>({detail:`HTTP ${r.status}`}));
      if (d.ok && d.background) {
        setSyncMsg(d.already_running ? '⟳ Загрузка уже идёт — обновите страницу через минуту'
                                     : '⟳ Загрузка запущена в фоне — обновите страницу через 1–2 минуты');
      } else if (d.ok) {
        setSyncMsg(`✓ Загружено ${d.fetched} начислений, новых строк: ${d.saved}` + (d.errors && d.errors.length ? ` (ошибки за ${d.errors.length} дн.)` : ''));
        reloadS();
        reloadT();
      } else {
        setSyncMsg(`✗ ${d.error || 'Ошибка'}`);
      }
    } catch(e) {
      setSyncMsg(`✗ ${e.message}`);
    }
    setSyncing(false);
    setTimeout(() => setSyncMsg(''), 6000);
  };

  const s = summary || {};
  const gross = s.gross_revenue || 0;
  const comm = s.commissions || 0;
  const logTotal = s.logistics || 0;
  const storage = s.storage || 0;
  const returns_ = s.returns || 0;
  const marketing = s.marketing || 0;
  const net = s.net_profit || 0;
  const margin = s.margin_pct || 0;
  const drr = s.drr_pct || 0;

  // P&L строки водопада
  const plRows = [
    {label: 'Выручка (брутто)', val: gross, dispVal: gross, color: P.teal, bold: true},
    {label: '− Комиссии Ozon', val: Math.abs(comm), dispVal: comm, color: P.red},
    {label: '− Логистика', val: Math.abs(logTotal), dispVal: logTotal, color: P.red},
    {label: '− Хранение', val: Math.abs(storage), dispVal: storage, color: P.yellow},
    {label: '− Возвраты', val: Math.abs(returns_), dispVal: returns_, color: P.red},
    {label: '− Реклама', val: Math.abs(marketing), dispVal: marketing, color: P.yellow},
    {label: '− Эквайринг, подписки, Premium, штрафы, прочее', val: Math.abs(s.other_deductions || 0), dispVal: s.other_deductions || 0, color: P.yellow},
    {label: '= Чистая прибыль', val: Math.abs(net), dispVal: net, color: net >= 0 ? P.teal : P.red, bold: true},
  ];

  const days = byDay || [];
  const maxRev = Math.max(...days.map(d => d.revenue || 0), 1);

  // Подписи категорий отдаёт сервер (все категории); запасные — на случай старого ответа
  const catLabels = {
    '': 'Все', sale: 'Продажи', return: 'Возвраты',
    storage: 'Хранение', logistics: 'Логистика',
    marketing: 'Реклама', correction: 'Корректировки', other: 'Прочее',
    ...(txData?.category_labels || {}),
  };

  const txItems = txData?.items || [];

  return (
    <div>
      {/* Toolbar */}
      <div className="toolbar">
        <div className="pills">
          {[7, 14, 30, 60, 90].map(d => (
            <button key={d} className={`pill ${period===d?'active':''}`} onClick={() => setPeriod(d)}>{d}д</button>
          ))}
        </div>
        <div style={{flex:1}}/>
        {syncMsg && (
          <span style={{fontSize:12, color: syncMsg.startsWith('✓') ? P.teal : syncMsg.startsWith('✗') ? P.red : P.muted}}>
            {syncMsg}
          </span>
        )}
        <button className="btn btn-p" onClick={syncNow} disabled={syncing}>
          {syncing ? '⟳ Загрузка...' : '↓ Синхронизировать'}
        </button>
      </div>

      {s.last_sync && (
        <div style={{fontSize:11, color: P.muted, marginBottom: 14}}>
          Последняя синхронизация: {new Date(s.last_sync).toLocaleString('ru-RU')}
        </div>
      )}

      {sl ? <Spin/> : se ? (
        <div className="alert alert-e">Не удалось загрузить финансы: {se}</div>
      ) : gross === 0 ? (
        <div className="alert alert-e">
          Данных нет. Нажмите «↓ Синхронизировать» чтобы загрузить финансовые операции из Ozon.
        </div>
      ) : (
        <>
          {/* KPI */}
          <div className="kpi-row">
            <KpiCard label="Выручка (брутто)" value={fmt.rub(gross)} color={P.teal} sub={`${s.sale_count || 0} заказов`}/>
            <KpiCard label="Комиссии Ozon" value={fmt.rub(comm)} color={P.red}/>
            <KpiCard label="Логистика" value={fmt.rub(logTotal)} color={P.red}/>
            <KpiCard label="Хранение" value={fmt.rub(storage)} color={P.yellow}/>
            <KpiCard label="Возвраты" value={fmt.rub(returns_)} color={P.red} sub={`${s.return_count || 0} шт.`}/>
          </div>

          {/* Net profit banner */}
          <div className="net-profit-box" style={{
            background: net >= 0 ? P.tealSoft : P.redSoft,
            border: `1px solid ${net >= 0 ? P.teal : P.red}`
          }}>
            <div>
              <div style={{fontSize:11, color:P.muted, textTransform:'uppercase', letterSpacing:'0.8px', fontWeight:700}}>Чистая прибыль</div>
              <div style={{fontSize:32, fontWeight:800, fontFamily:'JetBrains Mono', color: net >= 0 ? P.teal : P.red}}>
                {fmt.rub(net)}
              </div>
            </div>
            <div>
              <div style={{fontSize:11, color:P.muted, textTransform:'uppercase', letterSpacing:'0.8px', fontWeight:700}}>Маржа</div>
              <div style={{fontSize:32, fontWeight:800, fontFamily:'JetBrains Mono', color: margin >= 20 ? P.teal : margin >= 10 ? P.yellow : P.red}}>
                {fmt.pct(margin)}
              </div>
            </div>
            {marketing !== 0 && (
              <div>
                <div style={{fontSize:11, color:P.muted, textTransform:'uppercase', letterSpacing:'0.8px', fontWeight:700}}>ДРР (реклама/выручка)</div>
                <div style={{fontSize:32, fontWeight:800, fontFamily:'JetBrains Mono', color: drr > 20 ? P.red : drr > 10 ? P.yellow : P.teal}}>
                  {fmt.pct(drr)}
                </div>
              </div>
            )}
          </div>

          {/* P&L waterfall */}
          <div className="chart-box">
            <div className="sec-hdr"><div className="sec-title">P&amp;L разбивка</div></div>
            {plRows.map((row, i) => (
              <div key={i} className="pl-row">
                <div className="pl-label" style={{color: row.bold ? P.text : P.muted, fontWeight: row.bold ? 700 : 400}}>
                  {row.label}
                </div>
                <div className="pl-bar-track">
                  <div className="pl-bar-fill" style={{
                    width: gross > 0 ? `${Math.min(row.val / gross * 100, 100)}%` : '0%',
                    background: row.color,
                    opacity: row.bold ? 1 : 0.75
                  }}/>
                </div>
                <div className="pl-amount" style={{color: row.color, fontWeight: row.bold ? 700 : 400}}>
                  {row.dispVal >= 0 ? '' : '−'}{fmt.rub(Math.abs(row.dispVal))}
                </div>
              </div>
            ))}
          </div>

          {/* Daily revenue chart */}
          {days.length > 1 && (
            <div className="chart-box">
              <div className="sec-hdr">
                <div className="sec-title">Выручка и прибыль по дням</div>
                <div className="sec-badge">{days.length} дней</div>
              </div>
              <div className="chart-area">
                <svg width="100%" height="100%" viewBox={`0 0 ${days.length * 46} 140`} preserveAspectRatio="none">
                  {days.map((d, i) => {
                    const h = Math.max(4, (d.revenue || 0) / maxRev * 120);
                    const netH = Math.max(0, (d.net || 0) / maxRev * 120);
                    return (
                      <g key={i}>
                        <rect x={i*46+2} y={140-h} width={42} height={h} rx="3" fill={P.accentSoft}/>
                        <rect x={i*46+2} y={140-netH} width={42} height={Math.max(netH,0)} rx="3" fill={P.accent} opacity="0.85"/>
                        <text x={i*46+23} y={136} textAnchor="middle" fontSize="7" fill={P.dim}>{d.date?.slice(5)}</text>
                      </g>
                    );
                  })}
                </svg>
              </div>
              <div style={{display:'flex', gap:16, marginTop:8}}>
                <div style={{display:'flex', alignItems:'center', gap:6}}>
                  <div style={{width:12, height:12, background:P.accentSoft, borderRadius:2}}/>
                  <span style={{fontSize:11, color:P.muted}}>Выручка</span>
                </div>
                <div style={{display:'flex', alignItems:'center', gap:6}}>
                  <div style={{width:12, height:12, background:P.accent, borderRadius:2}}/>
                  <span style={{fontSize:11, color:P.muted}}>Чистый доход</span>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* Transactions table */}
      <div className="sec-hdr">
        <div className="sec-title">Транзакции</div>
        <div className="pills">
          {Object.entries(catLabels).map(([k, v]) => (
            <button key={k} className={`pill ${catFilter===k?'active':''}`} onClick={() => setCatFilter(k)}>
              {v}
            </button>
          ))}
        </div>
        {txData?.total != null && (
          <div className="sec-badge">{txData.total} шт.</div>
        )}
      </div>

      {tl ? <Spin/> : (
        <div className="tw">
          <table>
            <thead>
              <tr>
                <th>Категория</th>
                <th>Дата</th>
                <th>Отправление</th>
                <th className="r">Выручка</th>
                <th className="r">Комиссия</th>
                <th className="r">Сумма</th>
              </tr>
            </thead>
            <tbody>
              {txItems.map((tx, i) => {
                const catColor = {
                  sale: P.teal, return: P.red, storage: P.yellow,
                  logistics: P.yellow, marketing: P.yellow, correction: P.muted, other: P.muted
                }[tx.category] || P.muted;
                const catBg = {
                  sale: P.tealSoft, return: P.redSoft, storage: P.yellowSoft,
                  logistics: P.yellowSoft, marketing: P.yellowSoft, correction: P.border, other: P.border
                }[tx.category] || P.border;
                return (
                  <tr key={i}>
                    <td>
                      <span className="chip" style={{background: catBg, color: catColor}}>
                        {catLabels[tx.category] || tx.category}
                      </span>
                    </td>
                    <td className="mu">{tx.operation_date?.slice(0, 10)}</td>
                    <td className="mu" style={{fontFamily:'JetBrains Mono', fontSize:11}}>
                      {tx.posting_number || '—'}
                    </td>
                    <td className="r">
                      {tx.accruals_for_sale ? fmt.rub(tx.accruals_for_sale) : <span style={{color:P.dim}}>—</span>}
                    </td>
                    <td className="r" style={{color: P.red}}>
                      {tx.sale_commission ? fmt.rub(tx.sale_commission) : <span style={{color:P.dim}}>—</span>}
                    </td>
                    <td className="r" style={{color: tx.amount >= 0 ? P.teal : P.red, fontWeight: 700}}>
                      {tx.amount >= 0 ? '+' : ''}{fmt.rub(tx.amount)}
                    </td>
                  </tr>
                );
              })}
              {!txItems.length && (
                <tr>
                  <td colSpan={6}>
                    <div className="empty">
                      Нет данных. Нажмите «↓ Синхронизировать» чтобы загрузить транзакции.
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ── Dashboard ────────────────────────────────────────────────────────────────
function Dashboard({storeId}) {
  const {data:analytics,loading:al,error:ae}=useFetch("/api/analytics/live");
  const {data:stocks,loading:sl,error:se}=useFetch("/api/stocks/live");
  const [selected,setSelected]=useState(null);

  // Аналитика Ozon — по SKU (название приходит в строке), остатки — по product_id (название в остатке)
  const nameBySku={};
  (analytics||[]).forEach(r=>{if(r.sku&&r.name)nameBySku[r.sku]=r.name;});
  const nameByPid={};
  (stocks||[]).forEach(s=>{if(s.name)nameByPid[s.product_id]=s.name;});
  const getName=id=>nameBySku[id]||id;
  const getStockName=s=>nameByPid[s.product_id]||(s.sku&&nameBySku[s.sku])||s.offer_id||s.product_id;

  const loading=al||sl;
  const totals=(analytics||[]).reduce((a,r)=>({
    revenue:a.revenue+(r.revenue||0),orders:a.orders+(r.ordered_units||0),sessions:a.sessions+(r.sessions||0)
  }),{revenue:0,orders:0,sessions:0});
  const fboTotal=(stocks||[]).reduce((s,p)=>s+(p.fbo_present||0),0);
  const fbsTotal=(stocks||[]).reduce((s,p)=>s+(p.fbs_present||0),0);

  const byDate={};
  (analytics||[]).forEach(r=>{byDate[r.date]=(byDate[r.date]||0)+(r.revenue||0);});
  const dates=Object.keys(byDate).sort().slice(-14);
  const revSeries=dates.map(d=>byDate[d]);
  const maxRev=Math.max(...revSeries,1);

  const byProduct={};
  (analytics||[]).forEach(r=>{
    const id=r.sku||r.product_id;
    if(!byProduct[id])byProduct[id]={id,revenue:0,orders:0,sessions:0};
    byProduct[id].revenue+=r.revenue||0;
    byProduct[id].orders+=r.ordered_units||0;
    byProduct[id].sessions+=r.sessions||0;
  });
  const topProducts=Object.values(byProduct).sort((a,b)=>b.revenue-a.revenue).slice(0,8);
  const totalRevAll=topProducts.reduce((s,p)=>s+p.revenue,0)||1;

  const top10pct=new Set(topProducts.slice(0,Math.ceil(topProducts.length*0.3)).map(p=>String(p.id)));
  const critStocks=(stocks||[]).filter(s=>{
    const fbo=s.fbo_present||0;
    const isTop=top10pct.has(String(s.sku));
    return fbo<10||(isTop&&fbo<30);
  }).sort((a,b)=>(a.fbo_present||0)-(b.fbo_present||0)).slice(0,10);

  return (
    <div>
      {(ae||se)&&<div className="alert alert-e">Не удалось загрузить данные Ozon: {ae||se}. Цифры ниже могут быть неполными.</div>}
      {loading?<Spin/>:<>
        <div className="kpi-row">
          <KpiCard label="Выручка" value={fmt.rub(totals.revenue)} sub="за период" color={P.accent}/>
          <KpiCard label="Заказы" value={fmt.num(totals.orders)} sub="единиц" color={P.teal}/>
          <KpiCard label="Сессии" value={fmt.short(totals.sessions)} color={P.yellow}/>
          <KpiCard label="FBO остаток" value={fmt.num(fboTotal)} sub="на складе Ozon" color={P.accent}/>
          <KpiCard label="FBS остаток" value={fmt.num(fbsTotal)} sub="у продавца" color={P.teal}/>
        </div>

        {revSeries.length>1&&(
          <div className="chart-box">
            <div className="sec-hdr">
              <div className="sec-title">Выручка по дням</div>
              <div className="sec-badge">{dates.length} дней</div>
            </div>
            <div className="chart-area">
              <svg width="100%" height="100%" viewBox={`0 0 ${dates.length*46} 140`} preserveAspectRatio="none">
                {revSeries.map((v,i)=>{
                  const h=Math.max(4,v/maxRev*120);
                  return <g key={i}>
                    <rect x={i*46+2} y={140-h} width={42} height={h} rx="3"
                      fill={i===revSeries.length-1?P.accent:P.accentSoft}/>
                    <text x={i*46+23} y={136} textAnchor="middle" fontSize="7" fill={P.dim}>{dates[i]?.slice(5)}</text>
                  </g>;
                })}
              </svg>
            </div>
          </div>
        )}

        <div className="dash-grid">
          <div>
            <div className="sec-hdr"><div className="sec-title">Топ товаров по выручке</div></div>
            <div className="tw">
              <table>
                <thead><tr><th>Товар</th><th className="r">Выручка</th><th className="r">Доля</th><th className="r">Заказы</th></tr></thead>
                <tbody>
                  {topProducts.map((p,i)=>{
                    const pct=p.revenue/totalRevAll*100;
                    return <tr key={i} onClick={()=>setSelected({sku:p.id,name:getName(p.id),offer_id:""})}>
                      <td>
                        <div className="pname" title={getName(p.id)}>{getName(p.id)}</div>
                        <div className="rev-pct">
                          <div className="rev-pct-bar" style={{width:`${Math.min(pct*2,100)}px`}}/>
                          <span className="rev-pct-label">{pct.toFixed(1)}%</span>
                        </div>
                      </td>
                      <td className="r">{fmt.rub(p.revenue)}</td>
                      <td className="r"><span style={{color:pct>=10?P.teal:P.muted,fontWeight:pct>=10?700:400}}>{pct.toFixed(1)}%</span></td>
                      <td className="r">{p.orders}</td>
                    </tr>;
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div>
            <div className="sec-hdr">
              <div className="sec-title">⚠ Критичные остатки</div>
              <div className="sec-badge">FBO &lt;10 или топ-товары &lt;30</div>
            </div>
            <div className="tw">
              <table>
                <thead><tr><th>Товар</th><th className="r">FBO</th><th className="r">FBS</th><th className="r">Статус</th></tr></thead>
                <tbody>
                  {critStocks.map((s,i)=>{
                    const fbo=s.fbo_present||0;
                    const isTop=top10pct.has(String(s.sku));
                    const status=fbo===0?"zero":fbo<10?"warn":"fbo";
                    return <tr key={i} onClick={()=>setSelected({product_id:s.product_id,sku:s.sku,name:getStockName(s),offer_id:s.offer_id||""})}>
                      <td>
                        <div className="pname" title={getStockName(s)}>{getStockName(s)}</div>
                        {isTop&&<span className="chip warn" style={{fontSize:9,padding:"1px 4px"}}>ТОП</span>}
                      </td>
                      <td className="r"><span className={`chip ${status}`}>{fbo}</span></td>
                      <td className="r"><span className="chip fbs">{s.fbs_present||0}</span></td>
                      <td className="r" style={{fontSize:11,color:fbo===0?P.red:fbo<10?P.yellow:P.muted}}>
                        {fbo===0?"Нет":"Пополнить"}
                      </td>
                    </tr>;
                  })}
                  {!critStocks.length&&<tr><td colSpan={4}><div className="empty">🟢 Всё в норме</div></td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>}

      {selected&&<ProductModal
        product={selected}
        onClose={()=>setSelected(null)}
        allAnalytics={(analytics||[]).filter(r=>String(r.sku||r.product_id)===String(selected.product_id))}
        allStocks={stocks||[]}
      />}
    </div>
  );
}

// ── Analytics ────────────────────────────────────────────────────────────────
function Analytics(){
  const [period,setPeriod]=useState(30);
  const {data,loading,error,reload}=useFetch(`/api/analytics/live?days=${period}`,[period]);
  const [sort,setSort]=useState({key:"revenue",dir:-1});
  const [search,setSearch]=useState("");
  const [selected,setSelected]=useState(null);
  const {data:stocks}=useFetch("/api/stocks/live");

  const rows=data||[];
  // строки «день × SKU»; название товара приходит в самой строке
  const nameBySku={};
  rows.forEach(r=>{if(r.sku&&r.name)nameBySku[r.sku]=r.name;});
  const getName=id=>nameBySku[id]||String(id);

  const byProduct={};
  rows.forEach(r=>{
    const id=r.sku||r.product_id;
    if(!byProduct[id])byProduct[id]={id,revenue:0,orders:0,sessions:0,views:0,rows:[]};
    byProduct[id].revenue+=r.revenue||0;
    byProduct[id].orders+=r.ordered_units||0;
    byProduct[id].sessions+=r.sessions||0;
    byProduct[id].views+=r.hits_view||0;
    byProduct[id].rows.push(r);
  });

  const totalRev=Object.values(byProduct).reduce((s,p)=>s+p.revenue,0)||1;

  const filtered=Object.values(byProduct)
    .filter(p=>!search||getName(p.id).toLowerCase().includes(search.toLowerCase())||String(p.id).includes(search))
    .sort((a,b)=>((a[sort.key]||0)-(b[sort.key]||0))*sort.dir);

  const toggleSort=key=>setSort(s=>({key,dir:s.key===key?-s.dir:-1}));
  const si=key=>sort.key===key?(sort.dir===-1?"↓":"↑"):"↕";

  return(
    <div>
      <div className="toolbar">
        <div className="pills">
          {[7,14,30,60,90].map(d=><button key={d} className={`pill ${period===d?"active":""}`} onClick={()=>setPeriod(d)}>{d}д</button>)}
        </div>
        <input className="si" placeholder="Поиск..." value={search} onChange={e=>setSearch(e.target.value)}/>
        <div style={{flex:1}}/>
        <button className="btn btn-g" onClick={reload}>↺</button>
      </div>
      {error&&<div className="alert alert-e">Ошибка: {error}</div>}
      {loading?<Spin/>:(
        <div className="tw">
          <table>
            <thead><tr>
              <th>Товар</th>
              <th className={`r sth ${sort.key==="revenue"?"sd":""}`} onClick={()=>toggleSort("revenue")}>Выручка {si("revenue")}</th>
              <th className={`r sth ${sort.key==="orders"?"sd":""}`} onClick={()=>toggleSort("orders")}>Заказы {si("orders")}</th>
              <th className={`r sth ${sort.key==="sessions"?"sd":""}`} onClick={()=>toggleSort("sessions")}>Сессии {si("sessions")}</th>
              <th className="r">Конв.</th>
              <th className="r">Доля</th>
            </tr></thead>
            <tbody>
              {filtered.map((p,i)=>{
                const conv=p.sessions?(p.orders/p.sessions*100):0;
                const pct=p.revenue/totalRev*100;
                return <tr key={i} onClick={()=>setSelected({sku:p.id,name:getName(p.id),offer_id:""})}>
                  <td>
                    <div className="pname" title={getName(p.id)}>{getName(p.id)}</div>
                    <div className="pid">{p.id}</div>
                  </td>
                  <td className="r">{fmt.rub(p.revenue)}</td>
                  <td className="r">{fmt.num(p.orders)}</td>
                  <td className="r">{fmt.short(p.sessions)}</td>
                  <td className="r" style={{color:conv>3?P.teal:conv>1?P.yellow:P.red}}>{fmt.pct(conv)}</td>
                  <td className="r"><span style={{color:pct>=10?P.teal:P.muted}}>{pct.toFixed(1)}%</span></td>
                </tr>;
              })}
              {!filtered.length&&<tr><td colSpan={6}><div className="empty">Нет данных</div></td></tr>}
            </tbody>
          </table>
        </div>
      )}
      {selected&&<ProductModal
        product={selected}
        onClose={()=>setSelected(null)}
        allAnalytics={rows.filter(r=>String(r.sku||r.product_id)===String(selected.product_id))}
        allStocks={stocks||[]}
      />}
    </div>
  );
}

// ── Stocks ────────────────────────────────────────────────────────────────────
function Stocks(){
  const {data:stocks,loading,error,reload}=useFetch("/api/stocks/live");
  const {data:analytics}=useFetch("/api/analytics/by-sku?days=30");
  const [search,setSearch]=useState("");
  const [sort,setSort]=useState({key:"fbo_present",dir:-1});
  const [selected,setSelected]=useState(null);

  const getName=s=>s.name||s.offer_id||String(s.product_id);

  const velocity={};
  (analytics||[]).forEach(r=>{
    const id=String(r.sku||r.product_id);
    velocity[id]=(velocity[id]||0)+(r.ordered_units||0);
  });

  const maxFBO=Math.max(...(stocks||[]).map(s=>s.fbo_present||0),1);
  const filtered=(stocks||[])
    .filter(s=>!search||getName(s).toLowerCase().includes(search.toLowerCase())||(s.offer_id||"").toLowerCase().includes(search.toLowerCase())||String(s.product_id).includes(search))
    .sort((a,b)=>((a[sort.key]||0)-(b[sort.key]||0))*sort.dir);

  const toggleSort=key=>setSort(s=>({key,dir:s.key===key?-s.dir:-1}));
  const si=key=>sort.key===key?(sort.dir===-1?"↓":"↑"):"↕";

  const fboTotal=filtered.reduce((s,p)=>s+(p.fbo_present||0),0);
  const fbsTotal=filtered.reduce((s,p)=>s+(p.fbs_present||0),0);
  const zeroFBO=filtered.filter(p=>!p.fbo_present).length;

  return(
    <div>
      <div className="kpi-row m-kpi" style={{gridTemplateColumns:"repeat(4,1fr)",marginBottom:14}}>
        <KpiCard label="FBO (Ozon)" value={fmt.num(fboTotal)} color={P.accent} sub="на складе Ozon"/>
        <KpiCard label="FBS (свой)" value={fmt.num(fbsTotal)} color={P.yellow} sub="у продавца"/>
        <KpiCard label="Нулевые FBO" value={zeroFBO} color={P.red} sub="нет товара"/>
        <KpiCard label="Товаров" value={filtered.length} color={P.teal}/>
      </div>
      <div className="toolbar">
        <input className="si" placeholder="Поиск..." value={search} onChange={e=>setSearch(e.target.value)}/>
        <div style={{flex:1}}/>
        <button className="btn btn-g" onClick={reload}>↺</button>
      </div>
      {error&&<div className="alert alert-e">Ошибка: {error}</div>}
      {loading?<Spin/>:(
        <div className="tw">
          <table>
            <thead><tr>
              <th>Товар</th>
              <th className={`r sth ${sort.key==="fbo_present"?"sd":""}`} onClick={()=>toggleSort("fbo_present")}>FBO {si("fbo_present")}</th>
              <th className="r">Резерв</th>
              <th className={`r sth ${sort.key==="fbs_present"?"sd":""}`} onClick={()=>toggleSort("fbs_present")}>FBS {si("fbs_present")}</th>
              <th className="r">Продажи/30д</th>
              <th className="r">Дней остатка</th>
            </tr></thead>
            <tbody>
              {filtered.map((s,i)=>{
                const fbo=s.fbo_present||0;
                const vel=velocity[String(s.sku)]||velocity[String(s.product_id)]||0;
                const days=vel>0?Math.round(fbo/(vel/30)):null;
                const statusColor=fbo===0?P.red:fbo<10?P.yellow:P.accent;
                return <tr key={i} style={{cursor:"pointer"}} onClick={()=>setSelected({product_id:s.product_id,name:getName(s),offer_id:s.offer_id||String(s.product_id)})}>
                  <td>
                    <div className="pname" title={getName(s)}>{getName(s)}</div>
                    <div className="pid">{s.offer_id||s.product_id}</div>
                  </td>
                  <td className="r">
                    <div className="bar-w" style={{justifyContent:"flex-end"}}>
                      <div className="bar"><div className="bar-f" style={{width:`${(fbo/maxFBO*100).toFixed(0)}%`,"--bc":statusColor}}/></div>
                      <span className={`chip ${fbo===0?"zero":fbo<10?"warn":"fbo"}`}>{fbo}</span>
                    </div>
                  </td>
                  <td className="r">{(s.fbo_reserved||0)>0?<span className="chip rsv">{s.fbo_reserved}</span>:<span style={{color:P.dim}}>—</span>}</td>
                  <td className="r"><span className="chip fbs">{s.fbs_present||0}</span></td>
                  <td className="r" style={{color:P.muted}}>{vel||"—"}</td>
                  <td className="r">
                    {days!==null?<span style={{color:days<7?P.red:days<14?P.yellow:P.teal,fontWeight:700}}>{days}д</span>:<span style={{color:P.dim}}>—</span>}
                  </td>
                </tr>;
              })}
              {!filtered.length&&<tr><td colSpan={6}><div className="empty">Нет данных</div></td></tr>}
            </tbody>
          </table>
        </div>
      )}
      {selected&&<ProductModal
        product={selected}
        onClose={()=>setSelected(null)}
        allAnalytics={(analytics||[]).filter(r=>String(r.sku||r.product_id)===String(selected.product_id))}
        allStocks={stocks||[]}
      />}
    </div>
  );
}

// ── Products ────────────────────────────────────────────────────────────────
function Products(){
  const {data:products,loading,error,reload}=useFetch("/api/products/live");
  const {data:analytics}=useFetch("/api/analytics/live?days=30");
  const {data:stocks}=useFetch("/api/stocks/live");
  const [search,setSearch]=useState("");
  const [selected,setSelected]=useState(null);

  const ids=(products||[]).map(p=>p.product_id||p.id).filter(Boolean).map(Number);
  const names=useProductNames(ids);

  const enriched=(products||[]).map(p=>{
    const id=p.product_id||p.id;
    const info=names[id]||{};
    return {...p,_id:id,name:info.name||p.offer_id||String(id)};
  }).filter(p=>!search||p.name.toLowerCase().includes(search.toLowerCase())||String(p._id).includes(search));

  const rows=analytics||[];
  const velocity={};   // продажи за 30 дней по SKU
  rows.forEach(r=>{const id=String(r.sku||r.product_id);velocity[id]=(velocity[id]||0)+(r.ordered_units||0);});
  // product_id → SKU берём из остатков (в списке товаров Ozon SKU нет)
  const skuByPid={};
  (stocks||[]).forEach(s=>{if(s.sku)skuByPid[s.product_id]=String(s.sku);});

  return(
    <div>
      <div className="toolbar">
        <input className="si" placeholder="Поиск..." value={search} onChange={e=>setSearch(e.target.value)}/>
        <div style={{flex:1}}/>
        <button className="btn btn-g" onClick={reload}>↺</button>
      </div>
      {error&&<div className="alert alert-e">Ошибка: {error}</div>}
      {loading?<Spin/>:(
        <div className="tw">
          <table>
            <thead><tr>
              <th>Товар</th>
              <th className="r">Прод./30д</th>
              <th className="r">FBO</th>
              <th className="r">Статус</th>
            </tr></thead>
            <tbody>
              {enriched.map((p,i)=>(
                <tr key={i} onClick={()=>setSelected({...p,product_id:p._id,sku:skuByPid[p._id]})}>
                  <td>
                    <div className="pname" title={p.name}>{p.name}</div>
                    <div className="pid">{p.offer_id} · {p._id}</div>
                  </td>
                  <td className="r">{velocity[skuByPid[p._id]]||"—"}</td>
                  <td className="r">{(stocks||[]).find(s=>s.product_id===p._id)?.fbo_present??<span style={{color:P.dim}}>—</span>}</td>
                  <td className="r">
                    <span style={{color:p.archived?P.red:P.teal,fontSize:11,fontWeight:700}}>{p.archived?"Архив":"Активен"}</span>
                  </td>
                </tr>
              ))}
              {!enriched.length&&<tr><td colSpan={4}><div className="empty">Нет данных</div></td></tr>}
            </tbody>
          </table>
        </div>
      )}
      {selected&&<ProductModal
        product={selected}
        onClose={()=>setSelected(null)}
        allAnalytics={(analytics||[]).filter(r=>String(r.sku||r.product_id)===String(selected.product_id))}
        allStocks={stocks||[]}
      />}
    </div>
  );
}

// ── Settings: свои магазины ─────────────────────────────────────────────────
const SYNC_STATUS={ok:["✓ загружено",P.teal],partial:["⚠ частично",P.yellow],error:["✗ ошибка",P.red],running:["⟳ загружается",P.accent]};
const EMPTY_STORE={name:"",client_id:"",api_key:"",perf_client_id:"",perf_client_secret:""};

// Налог магазина: режим, ставка, НДС (сохраняется в магазине, используется в «Продажах»)
function TaxEditor({store,onSaved}){
  const [dict,setDict]=useState(null);
  const [edit,setEdit]=useState(false);
  const [form,setForm]=useState(null);
  const [err,setErr]=useState(null);
  const t=store.tax||{};
  useEffect(()=>{if(edit&&!dict)fetch(API+"/api/settings/tax-regimes").then(r=>r.json()).then(setDict).catch(()=>{});},[edit,dict]);
  const open=()=>{setForm({tax_regime:t.regime||"usn_income",tax_rate:String(t.rate??6),vat_rate:String(t.vat_rate??0)});setErr(null);setEdit(true);};
  const reg=dict?.regimes?.find(r=>r.id===form?.tax_regime);
  const save=async()=>{
    const rate=parseFloat(String(form.tax_rate).replace(",","."));
    // справочник не загрузился — НДС не трогаем (не обнуляем молча)
    const vat=!reg?undefined:(reg.vat?parseFloat(form.vat_rate):0);
    const body={tax_regime:form.tax_regime,tax_rate:isNaN(rate)?null:rate,...(vat===undefined?{}:{vat_rate:vat})};
    const r=await fetch(API+`/api/settings/stores/${store.id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)});
    const d=await r.json().catch(()=>({}));
    if(!r.ok){setErr(d.detail||"Ошибка");return;}
    setEdit(false);onSaved&&onSaved();
  };
  if(!edit)return(
    <div className="store-id" style={{whiteSpace:"normal"}}>
      Налог: {t.label||"—"}{t.rate!=null?`, ${t.rate}%`:""}{t.vat_rate?` + НДС ${t.vat_rate}%`:""}
      {" "}<button className="btn btn-g" style={{padding:"1px 8px",fontSize:11}} onClick={open}>изменить</button>
    </div>
  );
  return(
    <div style={{marginTop:8,display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}}>
      <select className="sinput" style={{width:"auto"}} value={form.tax_regime}
        onChange={e=>{const r=dict?.regimes?.find(x=>x.id===e.target.value);setForm(f=>({...f,tax_regime:e.target.value,tax_rate:String(r?r.rate:f.tax_rate),vat_rate:r&&r.vat?f.vat_rate:"0"}));}}>
        {(dict?.regimes||[{id:form.tax_regime,label:t.label||form.tax_regime}]).map(r=><option key={r.id} value={r.id}>{r.label}</option>)}
      </select>
      <input className="sinput" style={{width:80}} value={form.tax_rate} onChange={e=>setForm(f=>({...f,tax_rate:e.target.value}))} title="Ставка, %"/>%
      {reg&&reg.vat&&(
        <select className="sinput" style={{width:"auto"}} value={form.vat_rate} onChange={e=>setForm(f=>({...f,vat_rate:e.target.value}))} title="НДС">
          {(dict?.vat_rates||[0]).map(v=><option key={v} value={v}>{v?`НДС ${v}%`:"без НДС"}</option>)}
        </select>
      )}
      <button className="btn btn-p" onClick={save}>Сохранить</button>
      <button className="btn btn-g" onClick={()=>setEdit(false)}>Отмена</button>
      {err&&<span style={{color:P.red,fontSize:12}}>{err}</span>}
    </div>
  );
}

// Ключи рекламного кабинета Ozon (Performance API) у подключённого магазина
function AdsKeysEditor({store,onSaved}){
  const [edit,setEdit]=useState(false);
  const [form,setForm]=useState({perf_client_id:"",perf_client_secret:""});
  const [err,setErr]=useState(null);
  const [busy,setBusy]=useState(false);
  const save=async(clear)=>{
    setBusy(true);setErr(null);
    const body=clear?{perf_client_id:""}:{perf_client_id:form.perf_client_id.trim(),
      ...(form.perf_client_secret.trim()?{perf_client_secret:form.perf_client_secret.trim()}:{})};
    const r=await fetch(API+`/api/settings/stores/${store.id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)}).catch(()=>null);
    const d=r?await r.json().catch(()=>({})):{};
    setBusy(false);
    if(!r||!r.ok){setErr(d.detail||"Ошибка");return;}
    setEdit(false);onSaved&&onSaved();
  };
  if(!edit)return(
    <div className="store-id" style={{whiteSpace:"normal"}}>
      Рекламный кабинет: {store.perf_client_id?`подключён (${store.perf_client_id})`:"не подключён"}
      {" "}<button className="btn btn-g" style={{padding:"1px 8px",fontSize:11}}
        onClick={()=>{setForm({perf_client_id:store.perf_client_id||"",perf_client_secret:""});setErr(null);setEdit(true);}}>
        {store.perf_client_id?"изменить":"подключить"}</button>
    </div>
  );
  return(
    <div className="m-stack" style={{marginTop:8,display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}}>
      <input className="sinput" style={{width:220}} placeholder="Client-ID (Performance API)" value={form.perf_client_id}
        onChange={e=>setForm(f=>({...f,perf_client_id:e.target.value}))}/>
      <input className="sinput" style={{width:220}} type="password" autoComplete="off"
        placeholder={store.perf_client_id?"Client-Secret: пусто — не менять":"Client-Secret"} value={form.perf_client_secret}
        onChange={e=>setForm(f=>({...f,perf_client_secret:e.target.value}))}/>
      <button className="btn btn-p" disabled={busy||!form.perf_client_id.trim()} onClick={()=>save(false)}>{busy?"Проверяю…":"Сохранить"}</button>
      {store.perf_client_id&&<button className="btn btn-d" disabled={busy} onClick={()=>{if(window.confirm("Отключить рекламный кабинет?"))save(true);}}>Отключить</button>}
      <button className="btn btn-g" onClick={()=>setEdit(false)}>Отмена</button>
      {err&&<span style={{color:P.red,fontSize:12}}>{err}</span>}
    </div>
  );
}

// Смена пароля в личном кабинете (старые сессии на других устройствах закрываются)
function PasswordChange(){
  const [f,setF]=useState({old:"",nw:"",rep:""});
  const [msg,setMsg]=useState(null);
  const [busy,setBusy]=useState(false);
  const save=async()=>{
    if(f.nw!==f.rep){setMsg({ok:false,text:"Новые пароли не совпадают"});return;}
    setBusy(true);setMsg(null);
    try{
      const r=await fetch(API+"/api/auth/change-password",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({old_password:f.old,new_password:f.nw})});
      const d=await r.json().catch(()=>({}));
      if(!r.ok)throw new Error(d.detail||"Ошибка");
      if(d.token)localStorage.setItem("token",d.token);
      setF({old:"",nw:"",rep:""});
      setMsg({ok:true,text:"Пароль изменён. На других устройствах нужно войти заново."});
    }catch(e){setMsg({ok:false,text:e.message});}
    setBusy(false);
  };
  const inp=(k,label)=>(
    <div><div className="slabel">{label}</div>
      <input className="sinput" type="password" autoComplete={k==="old"?"current-password":"new-password"} value={f[k]} onChange={e=>setF(s=>({...s,[k]:e.target.value}))}/></div>
  );
  return(
    <div className="sc" style={{marginTop:16}}>
      <div style={{fontSize:14,fontWeight:700,marginBottom:10}}>Смена пароля</div>
      {msg&&<div className={`alert ${msg.ok?"alert-ok":"alert-e"}`}>{msg.text}</div>}
      <div className="sg">{inp("old","Текущий пароль")}{inp("nw","Новый пароль (от 8 символов)")}{inp("rep","Новый пароль ещё раз")}</div>
      <button className="btn btn-p" onClick={save} disabled={busy||!f.old||f.nw.length<8||!f.rep}>{busy?"...":"Сменить пароль"}</button>
    </div>
  );
}

function Settings({currentId,onStores,onSelect}){
  const [stores,setStores]=useState([]);
  const [showAdd,setShowAdd]=useState(false);
  const [newStore,setNewStore]=useState(EMPTY_STORE);
  const [busy,setBusy]=useState(false);
  const [msg,setMsg]=useState(null);

  const load=useCallback(()=>fetch(API+"/api/settings/stores").then(r=>r.json()).then(d=>{
    if(Array.isArray(d)){setStores(d);onStores&&onStores(d);}
  }).catch(()=>{}),[onStores]);
  useEffect(()=>{load();},[load]);
  // пока идёт загрузка — обновляем статус раз в 10 секунд
  useEffect(()=>{
    if(!stores.some(s=>s.syncing||s.last_sync_status==="running"))return;
    const t=setInterval(load,10000);return()=>clearInterval(t);
  },[stores,load]);
  useEffect(()=>{if(!stores.length)setShowAdd(true);},[stores.length]);

  const addStore=async()=>{
    setBusy(true);setMsg(null);
    try{
      const r=await fetch(API+"/api/settings/stores",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(newStore)});
      const d=await r.json().catch(()=>({detail:`HTTP ${r.status}`}));
      if(!r.ok)throw new Error(d.detail||"Ошибка");
      setShowAdd(false);setNewStore(EMPTY_STORE);
      setMsg({ok:true,text:"Магазин добавлен. Идёт первичная загрузка данных за 30 дней — обычно 2–10 минут."});
      await load();onSelect&&onSelect(d.id);
    }catch(e){setMsg({ok:false,text:e.message});}
    setBusy(false);
  };

  const deleteStore=async s=>{
    if(!window.confirm(`Удалить магазин «${s.name}» и все его загруженные данные?`))return;
    await fetch(API+`/api/settings/stores/${s.id}`,{method:"DELETE"});
    load();
  };

  const syncStore=async s=>{
    const r=await fetch(API+`/api/settings/stores/${s.id}/sync`,{method:"POST"});
    const d=await r.json().catch(()=>({detail:`HTTP ${r.status}`}));
    if(!r.ok){setMsg({ok:false,text:d.detail||`Ошибка HTTP ${r.status}`});return;}
    setMsg({ok:true,text:d.started?`Загрузка «${s.name}» запущена в фоне.`:`Загрузка «${s.name}» уже идёт.`});
    load();
  };

  const inp=(key,label,type="text",ph="")=>(
    <div>
      <div className="slabel">{label}</div>
      <input className="sinput" type={type} placeholder={ph} value={newStore[key]} onChange={e=>setNewStore(s=>({...s,[key]:e.target.value}))}/>
    </div>
  );

  return(
    <div>
      {msg&&<div className={`alert ${msg.ok?"alert-ok":"alert-e"}`}>{msg.text}</div>}

      <div className="sec-hdr">
        <div className="sec-title">Мои магазины Ozon</div>
        <div className="sec-badge">{stores.length}</div>
        <div style={{flex:1}}/>
        {!showAdd&&<button className="btn btn-p" onClick={()=>setShowAdd(true)}>+ Добавить магазин</button>}
      </div>

      {stores.map(s=>{
        const st=SYNC_STATUS[s.syncing?"running":s.last_sync_status]||["ещё не загружался",P.muted];
        const cur=s.id===currentId;
        return(
          <div key={s.id} className="store-card">
            <div className={`store-dot ${cur?"active":""}`}/>
            <div style={{flex:1,minWidth:0}}>
              <div className="store-name">{s.name}</div>
              <div className="store-id">Client-ID: {s.client_id}{s.perf_client_id?" · реклама подключена":""}</div>
              {!s.perf_client_id&&<div className="store-id" style={{whiteSpace:"normal",color:P.muted}}>
                Реклама оплачивается с рекламного счёта? Добавьте ключи рекламного кабинета (Performance API) —
                без них такая реклама не видна в финансах Ozon, а оплата за клик делится по товарам по продажам.
              </div>}
              <div className="store-id" style={{color:st[1]}}>
                {st[0]}{s.last_sync_at?` · ${new Date(s.last_sync_at.replace(" ","T")+"Z").toLocaleString("ru-RU")}`:""}
              </div>
              {s.last_sync_error&&!s.syncing&&<div className="store-id" style={{color:P.red,whiteSpace:"normal"}}>{s.last_sync_error.slice(0,300)}</div>}
              <TaxEditor store={s} onSaved={load}/>
              <AdsKeysEditor store={s} onSaved={load}/>
            </div>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              {cur?<span style={{fontSize:11,color:P.teal,fontWeight:700}}>● Открыт</span>
                  :<button className="btn btn-g" onClick={()=>onSelect&&onSelect(s.id)}>Открыть</button>}
              <button className="btn btn-g" title="Загрузить данные сейчас" onClick={()=>syncStore(s)} disabled={s.syncing}>⟳</button>
              <button className="btn btn-d" title="Удалить" onClick={()=>deleteStore(s)}>✕</button>
            </div>
          </div>
        );
      })}

      {showAdd&&(
        <div className="sc" style={{marginTop:12}}>
          <div style={{fontSize:14,fontWeight:700,marginBottom:6}}>{stores.length?"Новый магазин":"Подключите свой магазин Ozon"}</div>
          <div style={{fontSize:12,color:P.muted,marginBottom:14,lineHeight:1.7}}>
            Ключ создаётся в личном кабинете Ozon: <b>Настройки → Seller API → Сгенерировать ключ</b>, роль «Admin read only» достаточна.
            Ключи хранятся в зашифрованном виде и используются только для чтения данных вашего магазина.
            Рекламный кабинет (Performance API) — по желанию, но с ним точнее реклама по товарам, а реклама,
            оплаченная с отдельного рекламного счёта, без него не видна: ключ — в performance.ozon.ru →
            Настройки → API-ключи (сервисный аккаунт).
          </div>
          <div className="sg">
            {inp("name","Название","text","например, «Мой магазин»")}
            {inp("client_id","Client-ID (Seller API)","text","число из кабинета Ozon")}
            {inp("api_key","API-ключ (Seller API)","password")}
            {inp("perf_client_id","Performance Client-ID (необязательно)")}
          </div>
          <div style={{marginBottom:12}}>{inp("perf_client_secret","Performance Client-Secret (необязательно)","password")}</div>
          <div style={{display:"flex",gap:8}}>
            <button className="btn btn-p" onClick={addStore} disabled={busy||!newStore.name||!newStore.client_id||!newStore.api_key}>
              {busy?"⟳ Проверяю ключ в Ozon...":"Подключить"}
            </button>
            {stores.length>0&&<button className="btn btn-g" onClick={()=>setShowAdd(false)}>Отмена</button>}
          </div>
        </div>
      )}

      <div className="sc" style={{marginTop:16}}>
        <div style={{fontSize:13,color:P.muted,lineHeight:1.7}}>
          Данные всех ваших магазинов обновляются автоматически каждый день в <strong style={{color:P.text}}>06:00</strong>.
          Кнопка ⟳ у магазина запускает загрузку сразу.
        </div>
      </div>
      <PasswordChange/>
    </div>
  );
}

// ── Admin ───────────────────────────────────────────────────────────────────
// Реклама магазина за 30 дней: в финансах Ozon против рекламного кабинета (Performance API).
function AdsCheck({s}){
  const fin=Math.round(s.ads_fin_30||0), perf=Math.round(s.ads_perf_30||0);
  const rub=v=>v.toLocaleString("ru-RU")+" ₽";
  let text, color=P.muted;
  if(!s.has_perf){
    text=`реклама 30 дн: в финансах ${rub(fin)} · ключей рекламного кабинета нет`;
    if(!fin){text+=" — если реклама идёт с рекламного счёта, она не учитывается";color=P.red;}
  }else if(perf>fin*1.15){
    text=`реклама 30 дн: в финансах ${rub(fin)}, в кабинете ${rub(perf)} — разница с рекламного счёта учтена`;
    color=P.teal;
  }else{
    text=`реклама 30 дн: в финансах ${rub(fin)}, в кабинете ${rub(perf)}`;
    if(!perf&&fin)color=P.red, text+=" — кабинет не отдаёт расход, проверьте ключи";
  }
  return<div style={{color,fontSize:11,whiteSpace:"normal",maxWidth:520}}>{text}</div>;
}

function Admin(){
  const {data,loading,error,reload}=useFetch("/api/admin/users");
  const [q,setQ]=useState("");
  const act=async(url)=>{
    const r=await fetch(API+url,{method:"POST"}).catch(()=>null);
    if(!r||!r.ok){const d=r?await r.json().catch(()=>({})):{};window.alert(d.detail||"Не удалось выполнить действие");}
    reload();
  };
  const resetPwd=async u=>{
    if(!window.confirm(`Сбросить пароль ${u.email}? Будет создан временный пароль, все его сессии закроются.`))return;
    const r=await fetch(API+`/api/admin/users/${u.id}/reset-password`,{method:"POST"});
    const d=await r.json().catch(()=>({}));
    if(!r.ok){window.alert(d.detail||"Ошибка");return;}
    window.prompt(`Временный пароль для ${d.email} (показывается один раз — скопируйте и передайте пользователю; сменить — в разделе «Магазины»):`,d.temp_password);
  };
  if(loading)return<div className="empty"><div className="spin"/></div>;
  if(error)return<div className="alert alert-e">{error}</div>;
  const users=(data.users||[]).filter(u=>!q||u.email.includes(q.toLowerCase())||u.stores.some(s=>s.name.toLowerCase().includes(q.toLowerCase())||s.client_id.includes(q)));
  const st=s=>SYNC_STATUS[s.syncing?"running":s.last_sync_status]||["—",P.muted];
  const dt=v=>v?new Date(v.replace(" ","T")+"Z").toLocaleString("ru-RU",{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"}):"—";
  return(
    <div>
      <div className="sec-hdr">
        <div className="sec-title">Пользователи</div>
        <div className="sec-badge">{data.totals.users} польз. · {data.totals.stores} магаз. · ошибок загрузки: {data.totals.errors}</div>
        <div style={{flex:1}}/>
        <input className="si" placeholder="Поиск: email, магазин, Client-ID" value={q} onChange={e=>setQ(e.target.value)}/>
        <button className="btn btn-g" onClick={reload}>↺</button>
      </div>
      <div className="tw" style={{overflowX:"auto"}}>
        <table>
          <thead><tr><th>Пользователь</th><th>Регистрация</th><th>Последний вход</th><th>Магазины и загрузка</th><th></th></tr></thead>
          <tbody>
            {users.map(u=>(
              <tr key={u.id} style={u.is_blocked?{opacity:.5}:null}>
                <td><b>{u.email}</b>{u.is_admin?<span style={{color:P.accent,fontSize:11}}> · админ</span>:null}{u.is_blocked?<span style={{color:P.red,fontSize:11}}> · заблокирован</span>:null}</td>
                <td>{dt(u.created_at)}</td>
                <td>{dt(u.last_login)}</td>
                <td>
                  {u.stores.length===0&&<span style={{color:P.muted}}>нет магазинов</span>}
                  {u.stores.map(s=>(
                    <div key={s.id} style={{marginBottom:4}}>
                      {s.name} <span style={{color:P.muted}}>({s.client_id})</span>{" "}
                      <span style={{color:st(s)[1]}}>{st(s)[0]}</span> <span style={{color:P.muted}}>{dt(s.last_sync_at)}</span>
                      {" "}<button className="btn btn-g" style={{padding:"1px 6px"}} title="Загрузить сейчас" onClick={()=>act(`/api/admin/stores/${s.id}/sync`)}>⟳</button>
                      {s.last_sync_error&&<div style={{color:P.red,fontSize:11,whiteSpace:"normal",maxWidth:520}}>{s.last_sync_error.slice(0,200)}</div>}
                      <AdsCheck s={s}/>
                    </div>
                  ))}
                </td>
                <td style={{whiteSpace:"nowrap"}}>
                  <button className="btn btn-g" style={{marginRight:6}} onClick={()=>resetPwd(u)}>Сбросить пароль</button>
                  {!u.is_admin&&(u.is_blocked
                  ?<button className="btn btn-g" onClick={()=>act(`/api/admin/users/${u.id}/block?blocked=false`)}>Разблокировать</button>
                  :<button className="btn btn-d" onClick={()=>{if(window.confirm(`Заблокировать ${u.email}?`))act(`/api/admin/users/${u.id}/block?blocked=true`);}}>Заблокировать</button>)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Unit Economics ───────────────────────────────────────────────────────────
function UnitEconomics() {
  const [period, setPeriod] = useState(30);
  const [sort, setSort] = useState({ key: 'revenue', dir: -1 });
  const [search, setSearch] = useState('');
  const [editingSku, setEditingSku] = useState(null);
  const [editVal, setEditVal] = useState('');
  const [saving, setSaving] = useState(false);
  const [recatMsg, setRecatMsg] = useState('');

  const { data, loading, error, reload } = useFetch(`/api/ue/by-product?days=${period}`, [period]);

  const rows = (data || []).filter(r =>
    !search || (r.item_name || '').toLowerCase().includes(search.toLowerCase()) || r.sku?.includes(search)
  );

  const sorted = [...rows].sort((a, b) => ((a[sort.key] ?? 0) - (b[sort.key] ?? 0)) * sort.dir);
  const toggleSort = key => setSort(s => ({ key, dir: s.key === key ? -s.dir : -1 }));
  const si = key => sort.key === key ? (sort.dir === -1 ? ' ↓' : ' ↑') : '';

  const startEdit = (row) => {
    setEditingSku(row.sku);
    setEditVal(row.cost_price > 0 ? String(row.cost_price) : '');
  };

  const saveCost = async (sku, item_name) => {
    const val = parseFloat(editVal.replace(',', '.'));
    if (isNaN(val) || val < 0) return;
    setSaving(true);
    const r = await fetch(API + '/api/ue/cost-price', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sku, item_name, cost_price: val }),
    }).catch(() => null);
    setSaving(false);
    if (!r || !r.ok) { window.alert('Не удалось сохранить себестоимость' + (r ? ` (HTTP ${r.status})` : '')); return; }
    setEditingSku(null);
    reload();
  };

  const runRecategorize = async () => {
    setRecatMsg('⟳ Перекатегоризация...');
    const r = await fetch(API + '/api/ue/recategorize', { method: 'POST' }).catch(() => null);
    const d = r && r.ok ? await r.json().catch(() => null) : null;
    if (!d) { setRecatMsg(`✗ Ошибка${r ? ` HTTP ${r.status}` : ''}`); setTimeout(() => setRecatMsg(''), 4000); return; }
    setRecatMsg(`✓ Обновлено ${d.updated} записей`);
    setTimeout(() => setRecatMsg(''), 4000);
    reload();
  };

  // Суммарные метрики
  const totals = sorted.reduce((a, r) => ({
    orders: a.orders + (r.orders || 0),
    revenue: a.revenue + (r.revenue || 0),
    net: a.net + (r.net_before_cogs || 0),
    profit: a.profit + (r.net_profit ?? 0),
  }), { orders: 0, revenue: 0, net: 0, profit: 0 });

  const marginColor = m => m >= 25 ? P.teal : m >= 10 ? P.yellow : P.red;
  const withCost = sorted.filter(r => r.net_profit != null).length;

  return (
    <div>
      <div className="toolbar">
        <div className="pills">
          {[7, 14, 30, 60, 90].map(d => (
            <button key={d} className={`pill ${period === d ? 'active' : ''}`} onClick={() => setPeriod(d)}>{d}д</button>
          ))}
        </div>
        <input className="si" placeholder="Поиск по названию или SKU..." value={search} onChange={e => setSearch(e.target.value)} />
        <div style={{ flex: 1 }} />
        {recatMsg && <span style={{ fontSize: 12, color: recatMsg.startsWith('✓') ? P.teal : P.muted }}>{recatMsg}</span>}
        <button className="btn btn-g" onClick={runRecategorize} title="Пересчитать категории транзакций">⟳ Категории</button>
        <button className="btn btn-g" onClick={reload}>↺</button>
      </div>

      {error && <div className="alert alert-e">Ошибка: {error}</div>}

      {/* Суммарные KPI */}
      {!loading && sorted.length > 0 && (
        <div className="kpi-row" style={{ marginBottom: 16 }}>
          <KpiCard label="Товаров" value={sorted.length} color={P.accent} />
          <KpiCard label="Заказов" value={fmt.num(totals.orders)} color={P.teal} />
          <KpiCard label="Выручка" value={fmt.rub(totals.revenue)} color={P.teal} />
          <KpiCard label="Доход до с/с" value={fmt.rub(totals.net)} color={totals.net >= 0 ? P.teal : P.red} />
          <KpiCard label="Чистая прибыль" value={totals.profit ? fmt.rub(totals.profit) : '—'} color={totals.profit >= 0 ? P.teal : P.red}
            sub={withCost < sorted.length ? `только ${withCost} из ${sorted.length} товаров с себестоимостью` : "с себестоимостью"} />
        </div>
      )}

      <div style={{ fontSize: 11, color: P.muted, marginBottom: 10 }}>
        💡 Нажми на ячейку <strong style={{ color: P.text }}>Себест.</strong> чтобы ввести закупочную цену — появится чистая прибыль.
        Реклама, эквайринг, хранение и налог считаются как в разделе «Продажи»{sorted[0]?.tax_label ? ` (налог: ${sorted[0].tax_label})` : ''}.
      </div>

      {loading ? <Spin /> : (
        <div className="tw" style={{ overflowX: 'auto' }}>
          <table style={{ minWidth: 1300 }}>
            <thead>
              <tr>
                <th style={{ minWidth: 240 }}>Товар / SKU</th>
                <th className={`r sth${si('orders') ? ' sd' : ''}`} onClick={() => toggleSort('orders')}>Заказы{si('orders')}</th>
                <th className={`r sth${si('revenue') ? ' sd' : ''}`} onClick={() => toggleSort('revenue')}>Выручка{si('revenue')}</th>
                <th className={`r sth${si('commission_pct') ? ' sd' : ''}`} onClick={() => toggleSort('commission_pct')}>Комис.{si('commission_pct')}</th>
                <th className={`r sth${si('logistics_pct') ? ' sd' : ''}`} onClick={() => toggleSort('logistics_pct')}>Логист.{si('logistics_pct')}</th>
                <th className={`r sth${si('return_rate') ? ' sd' : ''}`} onClick={() => toggleSort('return_rate')}>Возвраты{si('return_rate')}</th>
                <th className={`r sth${si('ads_pct') ? ' sd' : ''}`} onClick={() => toggleSort('ads_pct')}>Реклама{si('ads_pct')}</th>
                <th className={`r sth${si('tax_pct') ? ' sd' : ''}`} onClick={() => toggleSort('tax_pct')} title="Налог и НДС по режиму магазина (с оплаты покупателя)">Налог{si('tax_pct')}</th>
                <th className={`r sth${si('margin_before_cogs') ? ' sd' : ''}`} onClick={() => toggleSort('margin_before_cogs')}>Маржа до с/с{si('margin_before_cogs')}</th>
                <th className="r" style={{ cursor: 'pointer', color: P.yellow }}>Себест. ₽</th>
                <th className={`r sth${si('profit_per_unit') ? ' sd' : ''}`} onClick={() => toggleSort('profit_per_unit')}>Прибыль/ед.{si('profit_per_unit')}</th>
                <th className={`r sth${si('net_profit') ? ' sd' : ''}`} onClick={() => toggleSort('net_profit')}>Итого прибыль{si('net_profit')}</th>
                <th className={`r sth${si('roi') ? ' sd' : ''}`} onClick={() => toggleSort('roi')}>ROI{si('roi')}</th>
              </tr>
            </thead>
            <tbody>
              {sorted.map((r, i) => {
                const isEditing = editingSku === r.sku;
                const hasCost = r.cost_price > 0;
                return (
                  <tr key={i}>
                    {/* Товар */}
                    <td>
                      <div className="pname" title={r.item_name} style={{ maxWidth: 280 }}>{r.item_name || '—'}</div>
                      <div className="pid">SKU: {r.sku}</div>
                    </td>
                    {/* Заказы */}
                    <td className="r">{fmt.num(r.orders)}</td>
                    {/* Выручка */}
                    <td className="r">
                      <div style={{ fontWeight: 700 }}>{fmt.rub(r.revenue)}</div>
                      <div style={{ fontSize: 10, color: P.muted }}>{fmt.rub(r.revenue_per_unit)}/ед.</div>
                    </td>
                    {/* Комиссия */}
                    <td className="r">
                      <div style={{ color: P.red }}>{fmt.pct(r.commission_pct)}</div>
                      <div style={{ fontSize: 10, color: P.muted }}>{fmt.rub(Math.abs(r.commissions))}</div>
                    </td>
                    {/* Логистика */}
                    <td className="r">
                      <div style={{ color: P.yellow }}>{fmt.pct(r.logistics_pct)}</div>
                      <div style={{ fontSize: 10, color: P.muted }}>{fmt.rub(r.logistics_per_unit)}/ед.</div>
                    </td>
                    {/* Возвраты */}
                    <td className="r">
                      <div style={{ color: r.return_rate > 10 ? P.red : r.return_rate > 3 ? P.yellow : P.teal }}>
                        {fmt.pct(r.return_rate)}
                      </div>
                      <div style={{ fontSize: 10, color: P.muted }}>{r.returns} шт.</div>
                    </td>
                    {/* Реклама */}
                    <td className="r">
                      <div style={{ color: r.ads_pct > 15 ? P.red : r.ads_pct > 8 ? P.yellow : P.teal }}>{fmt.pct(r.ads_pct)}</div>
                      <div style={{ fontSize: 10, color: P.muted }}>{fmt.rub(Math.abs(r.ads || 0))}</div>
                    </td>
                    {/* Налог */}
                    <td className="r" title={r.tax_label || ''}>
                      <div style={{ color: P.yellow }}>{fmt.pct(r.tax_pct)}</div>
                      <div style={{ fontSize: 10, color: P.muted }}>{fmt.rub(Math.abs(r.tax || 0))}</div>
                    </td>
                    {/* Маржа до с/с */}
                    <td className="r">
                      <div style={{ color: marginColor(r.margin_before_cogs), fontWeight: 700 }}>
                        {fmt.pct(r.margin_before_cogs)}
                      </div>
                      <div style={{ fontSize: 10, color: P.muted }}>{fmt.rub(r.net_before_cogs)}</div>
                    </td>
                    {/* Себестоимость — редактируемая */}
                    <td className="r" style={{ cursor: 'pointer' }} onClick={() => !isEditing && startEdit(r)}>
                      {isEditing ? (
                        <div style={{ display: 'flex', gap: 4, justifyContent: 'flex-end', alignItems: 'center' }}>
                          <input
                            autoFocus
                            value={editVal}
                            onChange={e => setEditVal(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') saveCost(r.sku, r.item_name); if (e.key === 'Escape') setEditingSku(null); }}
                            style={{ width: 70, background: P.surface, border: `1px solid ${P.accent}`, color: P.text, borderRadius: 4, padding: '3px 6px', fontSize: 12, fontFamily: 'JetBrains Mono', textAlign: 'right', outline: 'none' }}
                            placeholder="0"
                          />
                          <button className="btn btn-p" style={{ padding: '3px 7px', fontSize: 11 }} onClick={() => saveCost(r.sku, r.item_name)} disabled={saving}>✓</button>
                          <button className="btn btn-g" style={{ padding: '3px 7px', fontSize: 11 }} onClick={() => setEditingSku(null)}>✕</button>
                        </div>
                      ) : (
                        <div style={{ color: hasCost ? P.text : P.dim, borderBottom: `1px dashed ${hasCost ? P.dim : P.yellow}`, display: 'inline-block', minWidth: 60 }}>
                          {hasCost ? fmt.rub(r.cost_price) : <span style={{ color: P.yellow, fontSize: 11 }}>+ указать</span>}
                        </div>
                      )}
                    </td>
                    {/* Прибыль/ед. */}
                    <td className="r">
                      {r.profit_per_unit != null
                        ? <div style={{ color: r.profit_per_unit >= 0 ? P.teal : P.red, fontWeight: 700 }}>{fmt.rub(r.profit_per_unit)}</div>
                        : <span style={{ color: P.dim }}>—</span>}
                    </td>
                    {/* Итого прибыль */}
                    <td className="r">
                      {r.net_profit != null
                        ? <div style={{ color: r.net_profit >= 0 ? P.teal : P.red, fontWeight: 700 }}>{fmt.rub(r.net_profit)}</div>
                        : <span style={{ color: P.dim }}>—</span>}
                      {r.net_margin != null && (
                        <div style={{ fontSize: 10, color: marginColor(r.net_margin) }}>{fmt.pct(r.net_margin)}</div>
                      )}
                    </td>
                    {/* ROI */}
                    <td className="r">
                      {r.roi != null
                        ? <div style={{ color: r.roi >= 30 ? P.teal : r.roi >= 0 ? P.yellow : P.red, fontWeight: 700 }}>{fmt.pct(r.roi)}</div>
                        : <span style={{ color: P.dim }}>—</span>}
                    </td>
                  </tr>
                );
              })}
              {!sorted.length && (
                <tr><td colSpan={11}><div className="empty">
                  Нет данных. Сначала синхронизируйте финансы во вкладке Финансы.
                </div></td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}






// ── Supply (рекомендации поставок) ───────────────────────────────────────────
// ── Продажи: отчёт по каждой продаже ─────────────────────────────────────────
// Строка на продажу (цена → комиссия, логистика, эквайринг, РК, возвраты, себестоимость,
// НДС, налог → прибыль), итоги по товару, общие расходы магазина. Данные — /api/sales/report.

const SALE_COLS = [
  ["price", "Цена продавца"], ["buyer_paid", "Оплатил покупатель"], ["ozon_bonus", "Баллы Ozon"], ["commission", "Комиссия"], ["logistics", "Логистика"],
  ["acquiring", "Эквайринг"], ["ads", "Реклама"], ["returns", "Возвраты"], ["other", "Прочее"],
  ["cost", "Себест."], ["vat", "НДС"], ["tax", "Налог"], ["profit", "Прибыль"],
];

function Money({v, bold, profit}){
  const n = v ?? 0;
  const color = profit ? (n >= 0 ? P.teal : P.red) : (n < 0 ? P.text : n > 0 ? P.teal : P.muted);
  return <span style={{color, fontWeight: bold ? 700 : 400, whiteSpace: "nowrap"}}>{n ? fmt.rub(n) : "—"}</span>;
}

function Sales(){
  const [period, setPeriod] = useState(30);
  const [view, setView] = useState("sales");
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState({key: "date", dir: -1});
  const [openSku, setOpenSku] = useState(null);
  const [shown, setShown] = useState(200);
  const {data, loading, error, reload} = useFetch(`/api/sales/report?days=${period}`, [period]);

  const q = search.trim().toLowerCase();
  const match = r => !q || (r.name || "").toLowerCase().includes(q) || String(r.sku || "").includes(q)
                     || String(r.posting_number || "").toLowerCase().includes(q);
  const toggleSort = key => setSort(s => ({key, dir: s.key === key ? -s.dir : -1}));
  const si = key => sort.key === key ? (sort.dir === -1 ? " ↓" : " ↑") : "";
  const cmp = (a, b) => {
    const x = a[sort.key], y = b[sort.key];
    if (typeof x === "string" || typeof y === "string") return String(x ?? "").localeCompare(String(y ?? "")) * sort.dir;
    return ((x ?? -1e15) - (y ?? -1e15)) * sort.dir;
  };

  const t = data?.totals || {};
  const tax = data?.tax;
  const sales = (data?.sales || []).filter(match).sort(cmp);
  const products = (data?.products || []).filter(match).sort(cmp);
  const marginColor = m => m == null ? P.muted : m >= 20 ? P.teal : m >= 5 ? P.yellow : P.red;

  const head = (cols, extraFirst) => (
    <thead><tr>
      {extraFirst}
      {cols.map(([k, l]) => (
        <th key={k} className={`r sth${si(k) ? " sd" : ""}`} onClick={() => toggleSort(k)}>{l}{si(k)}</th>
      ))}
      <th className={`r sth${si("margin_pct") ? " sd" : ""}`} onClick={() => toggleSort("margin_pct")}>Маржа{si("margin_pct")}</th>
    </tr></thead>
  );

  return (
    <div>
      <div className="toolbar">
        <div className="pills">
          {[7, 14, 30, 60, 90].map(d => (
            <button key={d} className={`pill ${period === d ? "active" : ""}`} onClick={() => {setPeriod(d); setShown(200);}}>{d}д</button>
          ))}
        </div>
        <div className="pills">
          {[["sales", "По продажам"], ["products", "По товарам"], ["store", "Общие расходы"]].map(([id, l]) => (
            <button key={id} className={`pill ${view === id ? "active" : ""}`}
                    onClick={() => {setView(id); setSort({key: id === "sales" ? "date" : "price", dir: -1});}}>{l}</button>
          ))}
        </div>
        <input className="si" placeholder="Поиск: товар, SKU, отправление..." value={search} onChange={e => setSearch(e.target.value)}/>
        <div style={{flex: 1}}/>
        <button className="btn btn-g" onClick={reload}>↺</button>
      </div>

      {error && <div className="alert alert-e">Ошибка: {error}</div>}
      {loading ? <Spin/> : data && (
        <>
          <div className="kpi-row" style={{marginBottom: 12}}>
            <KpiCard label="Продаж" value={fmt.num(t.sales_count)} sub={t.returns_count ? `возвратов: ${t.returns_count}` : "за период"} color={P.accent}/>
            <KpiCard label="Выручка" value={fmt.rub(t.price)} sub={`оплатили покупатели ${fmt.rub(t.buyer_paid)} · баллы Ozon ${fmt.rub(t.ozon_bonus)}`} color={P.teal}/>
            <KpiCard label="Расходы Ozon" value={fmt.rub((t.commission || 0) + (t.logistics || 0) + (t.acquiring || 0) + (t.returns || 0) + (t.other || 0))} sub="комиссия, логистика, эквайринг, возвраты" color={P.red}/>
            <KpiCard label="Реклама" value={fmt.rub((t.ads || 0) + (t.ads_no_sales || 0))} sub={t.ads_no_sales ? `без продаж: ${fmt.rub(t.ads_no_sales)}` : ""} color={P.yellow}/>
            <KpiCard label="Налог" value={fmt.rub(t.tax)} sub={tax ? `${tax.label}, ${tax.rate}%${tax.vat_rate ? ` + НДС ${tax.vat_rate}%` : ""}${tax.base === "revenue" && tax.regime !== "none" ? " · с оплаты покупателей" : ""}` : ""} color={P.yellow}/>
            <KpiCard label="Чистая прибыль" value={fmt.rub(t.profit)} sub={t.margin_pct != null ? `маржа ${fmt.pct(t.margin_pct)} · с общими расходами` : "с общими расходами"} color={(t.profit || 0) >= 0 ? P.teal : P.red}/>
          </div>

          {t.no_split_count > 0 && (
            <div className="alert alert-e" style={{marginBottom: 10}}>
              У {t.no_split_count} продаж(и) Ozon не прислал разбивку «покупатель / баллы» — налог по ним посчитан с цены продавца (завышен).
              Нажмите ⟳ у магазина в «Магазинах», чтобы перезагрузить финансы за 30 дней.
            </div>
          )}
          {data.missing_cost?.length > 0 && (
            <div className="alert alert-e" style={{marginBottom: 10}}>
              Нет себестоимости у {data.missing_cost.length} товар(ов) — их прибыль завышена. Задайте её в разделе «Юнит-экономика».
            </div>
          )}

          {view === "sales" && (
            sales.length === 0 ? <div className="empty">Продаж за период нет (или финансы ещё загружаются).</div> : (
            <div className="tw" style={{overflowX: "auto"}}>
              <table style={{minWidth: 1350}}>
                {head(SALE_COLS, <>
                  <th className={`sth${si("date") ? " sd" : ""}`} onClick={() => toggleSort("date")}>Дата{si("date")}</th>
                  <th style={{minWidth: 220}}>Товар / отправление</th>
                  <th className="r">Шт.</th>
                </>)}
                <tbody>
                  {sales.slice(0, shown).map(s => (
                    <tr key={s.posting_number} style={s.returned ? {background: P.redSoft} : null}>
                      <td style={{whiteSpace: "nowrap"}}>{s.date}</td>
                      <td>
                        <div className="pname" title={s.name} style={{maxWidth: 260}}>{s.name || "—"}{s.returned ? " · возврат" : ""}</div>
                        <div className="pid">{s.posting_number} · SKU {s.sku}</div>
                      </td>
                      <td className="r">{s.qty}</td>
                      {SALE_COLS.map(([k]) => <td key={k} className="r"><Money v={s[k]} bold={k === "profit" || k === "price"} profit={k === "profit"}/></td>)}
                      <td className="r" style={{color: marginColor(s.margin_pct), fontWeight: 700}}>{s.margin_pct == null ? "—" : fmt.pct(s.margin_pct)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {sales.length > shown && (
                <div style={{textAlign: "center", padding: 10}}>
                  <button className="btn btn-g" onClick={() => setShown(n => n + 500)}>Показать ещё ({sales.length - shown})</button>
                </div>
              )}
            </div>
          ))}

          {view === "products" && (
            products.length === 0 ? <div className="empty">Нет данных за период.</div> : (
            <div className="tw" style={{overflowX: "auto"}}>
              <table style={{minWidth: 1400}}>
                {head([["sales", "Продаж"], ...SALE_COLS.slice(0, -1), ["ads_no_sales", "РК без продаж"], ["sku_expenses", "Хранение и пр."], ["profit", "Прибыль"]],
                  <th style={{minWidth: 240}}>Товар</th>)}
                <tbody>
                  {products.map(p => (
                    <React.Fragment key={p.sku}>
                      <tr style={{cursor: "pointer"}} onClick={() => setOpenSku(openSku === p.sku ? null : p.sku)}>
                        <td>
                          <div className="pname" title={p.name} style={{maxWidth: 280}}>{openSku === p.sku ? "▾ " : "▸ "}{p.name || "—"}</div>
                          <div className="pid">SKU {p.sku}{p.returns_count ? ` · возвратов ${p.returns_count}` : ""}</div>
                        </td>
                        <td className="r">{fmt.num(p.sales)}</td>
                        {[...SALE_COLS.slice(0, -1).map(([k]) => k), "ads_no_sales", "sku_expenses", "profit"].map(k => (
                          <td key={k} className="r"><Money v={p[k]} bold={k === "profit" || k === "price"} profit={k === "profit"}/></td>
                        ))}
                        <td className="r" style={{color: marginColor(p.margin_pct), fontWeight: 700}}>{p.margin_pct == null ? "—" : fmt.pct(p.margin_pct)}</td>
                      </tr>
                      {openSku === p.sku && (data.sales || []).filter(s => s.sku === p.sku).map(s => (
                        <tr key={s.posting_number} style={{background: P.surface, fontSize: 12}}>
                          <td style={{paddingLeft: 24}}><span className="pid">{s.date} · {s.posting_number}{s.returned ? " · возврат" : ""}</span></td>
                          <td className="r">{s.qty} шт.</td>
                          {SALE_COLS.slice(0, -1).map(([k]) => <td key={k} className="r"><Money v={s[k]}/></td>)}
                          <td className="r">—</td><td className="r">—</td>
                          <td className="r"><Money v={s.profit} profit/></td>
                          <td className="r" style={{color: marginColor(s.margin_pct)}}>{s.margin_pct == null ? "—" : fmt.pct(s.margin_pct)}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          ))}

          {view === "store" && (
            <div className="sc">
              <div style={{fontSize: 14, fontWeight: 700, marginBottom: 10}}>Расходы магазина без привязки к продаже</div>
              {(data.store_expenses || []).length === 0 ? <div style={{color: P.muted}}>За период нет.</div> : (
                <table><tbody>
                  {data.store_expenses.map(e => (
                    <tr key={e.category}><td>{e.label}</td><td className="r"><Money v={e.amount} bold/></td></tr>
                  ))}
                  <tr><td style={{fontWeight: 700}}>Итого</td><td className="r"><Money v={t.store_expenses} bold/></td></tr>
                </tbody></table>
              )}
              <div style={{fontSize: 14, fontWeight: 700, margin: "18px 0 10px"}}>Итог периода</div>
              <table><tbody>
                {[["Выручка (цена продавца)", t.price], ["  в т.ч. оплатили покупатели — база налога «доходы»", t.buyer_paid], ["  в т.ч. баллы и соинвест Ozon", t.ozon_bonus], ["Комиссия Ozon", t.commission], ["Логистика", t.logistics], ["Эквайринг", t.acquiring],
                  ["Возвраты", t.returns], ["Прочее по продажам", t.other], ["Реклама (по продажам)", t.ads],
                  ["Реклама без продаж", t.ads_no_sales], ["Хранение и прочее по товарам", t.sku_expenses],
                  ["Общие расходы магазина", t.store_expenses], ["Себестоимость", t.cost], ["НДС", t.vat], ["Налог", t.tax]]
                  .map(([l, v]) => <tr key={l}><td>{l}</td><td className="r"><Money v={v}/></td></tr>)}
                <tr><td style={{fontWeight: 700}}>Чистая прибыль</td><td className="r"><Money v={t.profit} bold profit/></td></tr>
              </tbody></table>
            </div>
          )}

          <div style={{fontSize: 11, color: P.muted, marginTop: 12, lineHeight: 1.7}}>
            {(data.notes || []).map((n, i) => <div key={i}>• {n}</div>)}
            <div>• Налог магазина задаётся в разделе «Магазины».</div>
          </div>
        </>
      )}
    </div>
  );
}

function Supply(){
  const [target,setTarget]=useState(30);
  const [search,setSearch]=useState("");
  const [sel,setSel]=useState(null);
  const {data,loading,error,reload}=useFetch(`/api/supply/?days=30&target_days=${target}`,[target]);

  const q=search.trim().toLowerCase();
  const items=(data?.items||[]).filter(i=>!q||(i.name||"").toLowerCase().includes(q)||(i.offer_id||"").toLowerCase().includes(q));
  const selected=sel?items.find(i=>i.offer_id===sel)||null:null;

  return(
    <div>
      <div className="toolbar">
        <div className="pills">
          {[[14,"на 2 нед"],[30,"на месяц"],[45,"на 1.5 мес"]].map(([d,l])=><button key={d} className={`pill ${target===d?"active":""}`} onClick={()=>setTarget(d)}>{l}</button>)}
        </div>
        <input className="si" placeholder="Товар или артикул..." value={search} onChange={e=>{setSearch(e.target.value);setSel(null);}}/>
        <div style={{flex:1}}/>
        <button className="btn btn-g" onClick={reload}>↺</button>
      </div>
      {error&&<div className="alert alert-e">Ошибка: {error}</div>}
      {loading?<Spin/>:data&&(
        <div className="m-stack" style={{display:"grid",gridTemplateColumns:"2fr 3fr",gap:14,alignItems:"start"}}>
          <div className="tw">
            <div style={{padding:"10px 12px",color:P.muted,fontSize:13,fontWeight:600}}>Товары — что везти в первую очередь</div>
            <table>
              <thead><tr><th>Товар</th><th className="r">Спрос 30д</th><th className="r">Остаток</th><th className="r">Везти</th></tr></thead>
              <tbody>
                {items.slice(0,80).map(i=>(
                  <tr key={i.offer_id} onClick={()=>setSel(s=>s===i.offer_id?null:i.offer_id)}
                      style={{cursor:"pointer",background:sel===i.offer_id?P.accentSoft:"transparent"}}>
                    <td>
                      <div style={{maxWidth:170,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{i.name||i.offer_id}</div>
                      <div style={{color:P.dim,fontSize:11}}>{i.offer_id}</div>
                    </td>
                    <td className="r">{fmt.num(i.total_units)}</td>
                    <td className="r">{fmt.num(i.total_stock)}</td>
                    <td className="r">{i.total_recommend>0?<b style={{color:P.yellow}}>{fmt.num(i.total_recommend)}</b>:<span style={{color:P.teal}}>✓</span>}</td>
                  </tr>
                ))}
                {!items.length&&<tr><td colSpan={4}><div className="empty">Нет данных. Сначала синхронизируй Географию (90д).</div></td></tr>}
              </tbody>
            </table>
          </div>
          <div className="tw">
            <div style={{padding:"10px 12px",color:P.muted,fontSize:13,fontWeight:600}}>
              {selected?`Кластеры: ${selected.name||selected.offer_id}`:"Выбери товар слева — покажу разбивку по кластерам"}
            </div>
            {selected&&(
              <table>
                <thead><tr><th>Кластер</th><th className="r">Заказов 30д</th><th className="r">Спрос/день</th><th className="r">Остаток</th><th className="r">В пути</th><th className="r">Хватит на</th><th className="r">Отправить</th></tr></thead>
                <tbody>
                  {selected.clusters.map(c=>(
                    <tr key={c.cluster}>
                      <td>{c.cluster}</td>
                      <td className="r">{fmt.num(c.units_period)}</td>
                      <td className="r">{c.daily}</td>
                      <td className="r">{fmt.num(c.stock)}</td>
                      <td className="r" style={{color:P.muted}}>{c.in_transit||"—"}</td>
                      <td className="r">
                        {c.days_left==null?<span style={{color:P.dim}}>—</span>
                          :<span style={{color:c.days_left<7?P.red:c.days_left<14?P.yellow:P.teal,fontWeight:700}}>{c.days_left}д</span>}
                      </td>
                      <td className="r">{c.recommend>0?<b style={{color:P.yellow,fontSize:15}}>{fmt.num(c.recommend)}</b>:<span style={{color:P.teal}}>✓</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {selected&&<div style={{padding:"10px 12px",color:P.muted,fontSize:12}}>
              Формула: спрос/день × {data.target_days} дн. × страховой запас {data.safety_pct}% − остаток − в пути. Спрос считается по заказам за 30 дней из базы (вкладка География должна быть синхронизирована).
            </div>}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Orders (живая лента) ─────────────────────────────────────────────────────
function Profit({p}){
  if(p.profit==null)return <span style={{color:P.dim}}>—</span>;
  return <span style={{color:p.profit>=0?P.teal:P.red,fontWeight:700}} title={p.has_cogs?"с учётом себестоимости":"без себестоимости — задай её в Юнит-экономике"}>
    {fmt.rub(p.profit)}{!p.has_cogs&&<span style={{color:P.yellow}}>*</span>}</span>;
}
function Orders(){
  const [period,setPeriod]=useState(1);
  const [auto,setAuto]=useState(true);
  const [search,setSearch]=useState("");
  const [sortKey,setSortKey]=useState("units");
  const {data,loading,error,reload}=useFetch(`/api/orders/live?days=${period}`,[period]);

  // автообновление раз в 60 секунд
  useEffect(()=>{
    if(!auto)return;
    const t=setInterval(reload,60000);
    return ()=>clearInterval(t);
  },[auto,reload]);

  const q=search.trim().toLowerCase();
  const orders=(data?.orders||[]).filter(o=>!q||o.items.some(i=>(i.name||"").toLowerCase().includes(q)||(i.offer_id||"").toLowerCase().includes(q)));
  const products=(data?.products||[]).filter(p=>!q||(p.name||"").toLowerCase().includes(q)||(p.offer_id||"").toLowerCase().includes(q));
  const sorted=[...products].sort((a,b)=>(b[sortKey]??-1e12)-(a[sortKey]??-1e12));
  const tot=products.reduce((t,p)=>({orders:t.orders+(p.orders||0),units:t.units+(p.units||0),
    revenue:t.revenue+(p.revenue||0),costs:t.costs+(p.costs||0),profit:t.profit+(p.profit||0)}),
    {orders:0,units:0,revenue:0,costs:0,profit:0});
  const marginOf=p=>p.profit!=null&&p.revenue>0?p.profit/p.revenue*100:null;

  const STATUS_COLORS={"Доставлен":P.teal,"Доставляется":P.accent,"Отменён":P.red,"Ожидает упаковки":P.yellow,"Ожидает отгрузки":P.yellow};
  const timeOf=s=>{try{return new Date(s).toLocaleString("ru-RU",{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"});}catch{return s;}};

  return(
    <div>
      <div className="toolbar">
        <div className="pills">
          {[[1,"Сегодня"],[2,"2 дня"],[7,"Неделя"]].map(([d,l])=><button key={d} className={`pill ${period===d?"active":""}`} onClick={()=>setPeriod(d)}>{l}</button>)}
        </div>
        <input className="si" placeholder="Товар или артикул..." value={search} onChange={e=>setSearch(e.target.value)}/>
        <div style={{flex:1}}/>
        <label style={{display:"flex",alignItems:"center",gap:6,color:P.muted,fontSize:13,cursor:"pointer"}}>
          <input type="checkbox" checked={auto} onChange={e=>setAuto(e.target.checked)}/>авто-обновление
        </label>
        <button className="btn btn-g" onClick={reload}>↺</button>
      </div>
      {error&&<div className="alert alert-e">Ошибка: {error}</div>}
      {loading&&!data?<Spin/>:data&&(
        <>
          <div className="grid grid-4" style={{marginBottom:14}}>
            <KpiCard label="Заказов сегодня" value={fmt.num(data.today.orders)} sub={`обновлено ${data.updated_at}`}/>
            <KpiCard label="Штук сегодня" value={fmt.num(data.today.units)} color={P.teal}/>
            <KpiCard label="Выручка сегодня" value={fmt.rub(data.today.revenue)} color={P.accent}/>
            <KpiCard label="Всего за период" value={fmt.num(data.total_orders)} sub={period===1?"сегодня":`${period} дн.`} color={P.yellow}/>
          </div>
          <div className="ord-head">
            <span>По товарам за период {auto&&<span style={{color:P.teal}}>● live</span>}</span>
            <div className="pills">
              {[["units","Штуки"],["revenue","Выручка"],["profit","Прибыль"]].map(([k,l])=>(
                <button key={k} className={`pill ${sortKey===k?"active":""}`} onClick={()=>setSortKey(k)}>{l}</button>))}
            </div>
          </div>
          {/* Компьютер: таблица */}
          <div className="tw m-hide">
            <table>
              <thead><tr><th>Товар</th><th className="r">Заказы</th><th className="r">Штук</th><th className="r">Выручка</th><th className="r">Расходы</th><th className="r">Прибыль</th><th className="r">Маржа</th></tr></thead>
              <tbody>
                {sorted.map(p=>(
                  <tr key={p.offer_id}>
                    <td>
                      <div className="ord-name" title={p.name}>{p.name||p.offer_id}</div>
                      <div style={{color:P.dim,fontSize:11}}>{p.offer_id}</div>
                    </td>
                    <td className="r">{fmt.num(p.orders)}</td>
                    <td className="r"><b>{fmt.num(p.units)}</b></td>
                    <td className="r">{fmt.rub(p.revenue)}</td>
                    <td className="r" style={{color:P.muted}}>{p.costs!=null?fmt.rub(p.costs):"—"}</td>
                    <td className="r"><Profit p={p}/></td>
                    <td className="r" style={{color:P.muted}}>{marginOf(p)!=null?`${fmt.num(marginOf(p),0)}%`:"—"}</td>
                  </tr>
                ))}
                {!!sorted.length&&(
                  <tr className="ord-total">
                    <td><b>Итого</b> <span style={{color:P.dim,fontSize:11}}>{sorted.length} товаров</span></td>
                    <td className="r">{fmt.num(tot.orders)}</td>
                    <td className="r"><b>{fmt.num(tot.units)}</b></td>
                    <td className="r">{fmt.rub(tot.revenue)}</td>
                    <td className="r" style={{color:P.muted}}>{fmt.rub(tot.costs)}</td>
                    <td className="r"><b style={{color:tot.profit>=0?P.teal:P.red}}>{fmt.rub(tot.profit)}</b></td>
                    <td className="r" style={{color:P.muted}}>{tot.revenue?`${fmt.num(tot.profit/tot.revenue*100,0)}%`:"—"}</td>
                  </tr>
                )}
                {!sorted.length&&<tr><td colSpan={7}><div className="empty">Заказов нет</div></td></tr>}
              </tbody>
            </table>
          </div>
          {/* Телефон: карточка на товар — всё видно без прокрутки вбок */}
          <div className="m-only ord-cards">
            {sorted.map(p=>(
              <div key={p.offer_id} className="ord-card">
                <div className="ord-top">
                  <div style={{minWidth:0}}>
                    <div className="ord-name">{p.name||p.offer_id}</div>
                    <div style={{color:P.dim,fontSize:11}}>{p.offer_id}</div>
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}>
                    <div style={{fontSize:15}}><Profit p={p}/></div>
                    <div style={{color:P.dim,fontSize:11}}>{marginOf(p)!=null?`маржа ${fmt.num(marginOf(p),0)}%`:"прибыль"}</div>
                  </div>
                </div>
                <div className="ord-stats">
                  <div><span>Штук</span><b>{fmt.num(p.units)}</b></div>
                  <div><span>Заказов</span>{fmt.num(p.orders)}</div>
                  <div><span>Выручка</span>{fmt.rub(p.revenue)}</div>
                  <div><span>Расходы</span>{p.costs!=null?fmt.rub(p.costs):"—"}</div>
                </div>
              </div>
            ))}
            {!!sorted.length&&(
              <div className="ord-card ord-total">
                <div className="ord-top"><b>Итого · {sorted.length} товаров</b><b style={{color:tot.profit>=0?P.teal:P.red}}>{fmt.rub(tot.profit)}</b></div>
                <div className="ord-stats">
                  <div><span>Штук</span><b>{fmt.num(tot.units)}</b></div>
                  <div><span>Заказов</span>{fmt.num(tot.orders)}</div>
                  <div><span>Выручка</span>{fmt.rub(tot.revenue)}</div>
                  <div><span>Расходы</span>{fmt.rub(tot.costs)}</div>
                </div>
              </div>
            )}
            {!sorted.length&&<div className="empty">Заказов нет</div>}
          </div>
        </>
      )}
    </div>
  );
}

// ── Geography ────────────────────────────────────────────────────────────────
function Geography(){
  const [period,setPeriod]=useState(30);
  const [search,setSearch]=useState("");
  const [selRegion,setSelRegion]=useState(null);
  const [syncing,setSyncing]=useState(false);
  const [syncMsg,setSyncMsg]=useState("");
  const {data,loading,error,reload}=useFetch(`/api/geo/?days=${period}`,[period]);

  const doSync=async(d)=>{
    setSyncing(true);setSyncMsg("Выгрузка из Ozon, это может занять пару минут...");
    try{
      const r=await fetch(`/api/geo/sync?days=${d}`,{method:"POST"});
      const j=await r.json().catch(()=>({detail:`HTTP ${r.status}`}));
      if(!r.ok)throw new Error(j.detail||"Ошибка синхронизации");
      setSyncMsg(`Готово: ${j.fetched} отправлений, ${j.saved_rows} новых строк`);
      reload();
    }catch(e){setSyncMsg("Ошибка: "+e.message);}
    finally{setSyncing(false);}
  };

  const matrix=data?.matrix||[];
  const q=search.trim().toLowerCase();

  // фильтр по артикулу/названию
  const fMatrix=q?matrix.filter(c=>(c.offer_id||"").toLowerCase().includes(q)||(c.name||"").toLowerCase().includes(q)):matrix;

  // регионы: при поиске пересчитываем из матрицы, иначе берём готовые
  const regions=q
    ?Object.values(fMatrix.reduce((acc,c)=>{
        const r=acc[c.region]||(acc[c.region]={region:c.region,orders:0,units:0,revenue:0,top_cities:""});
        r.orders+=c.orders;r.units+=c.units;r.revenue+=c.revenue;return acc;
      },{})).sort((a,b)=>b.orders-a.orders)
    :(data?.regions||[]);

  const totalUnits=regions.reduce((s,r)=>s+r.units,0)||1;

  // товары выбранного региона (или все)
  const skuRows=Object.values(fMatrix
    .filter(c=>!selRegion||c.region===selRegion)
    .reduce((acc,c)=>{
      const r=acc[c.offer_id]||(acc[c.offer_id]={offer_id:c.offer_id,name:c.name,units:0,orders:0,revenue:0});
      r.units+=c.units;r.orders+=c.orders;r.revenue+=c.revenue;return acc;
    },{})).sort((a,b)=>b.units-a.units).slice(0,50);

  const exportCsv=()=>{
    const head="Артикул;Товар;Регион;Заказы;Штук;Выручка";
    const lines=fMatrix.map(c=>[`"${c.offer_id}"`,`"${c.name}"`,`"${c.region}"`,c.orders,c.units,c.revenue].join(";"));
    const blob=new Blob(["\ufeff"+[head,...lines].join("\n")],{type:"text/csv;charset=utf-8"});
    const a=document.createElement("a");a.href=URL.createObjectURL(blob);a.download=`geografiya_${period}d.csv`;a.click();
  };

  return(
    <div>
      <div className="toolbar">
        <div className="pills">
          {[7,14,30,60,90].map(d=><button key={d} className={`pill ${period===d?"active":""}`} onClick={()=>setPeriod(d)}>{d}д</button>)}
        </div>
        <input className="si" placeholder="Артикул или название..." value={search} onChange={e=>{setSearch(e.target.value);setSelRegion(null);}}/>
        <div style={{flex:1}}/>
        <button className="btn btn-g" disabled={syncing} onClick={()=>doSync(period)}>{syncing?"...":"⟳ Синхронизировать"}</button>
        <button className="btn btn-g" onClick={exportCsv}>⇩ CSV</button>
        <button className="btn btn-g" onClick={reload}>↺</button>
      </div>
      {syncMsg&&<div className="alert" style={{borderColor:P.accent,color:P.text,background:P.accentSoft,padding:"8px 12px",borderRadius:8,marginBottom:12}}>{syncMsg}</div>}
      {error&&<div className="alert alert-e">Ошибка: {error}</div>}
      {!loading&&data&&data.first_date&&(
        <div style={{color:P.muted,fontSize:12,marginBottom:10}}>
          Данные в базе: {data.first_date} — {data.last_date}. Если выбранный период больше этого диапазона, нажми «Синхронизировать».
        </div>
      )}
      {!loading&&data&&!(data.items||[]).length&&(
        <div className="card" style={{padding:20,marginBottom:14,textAlign:"center",color:P.muted}}>
          Данных воронки за период нет. Нажми «Синхронизировать» — при первом запуске выгрузится воронка за выбранный период (лучше выбрать 90д).
        </div>
      )}
      {loading?<Spin/>:data&&(
        <>
          <div className="grid grid-4" style={{marginBottom:14}}>
            <KpiCard label="Заказов" value={fmt.num(q?regions.reduce((s,r)=>s+r.orders,0):data.total_orders)} sub={`за ${data.days} дней`}/>
            <KpiCard label="Регионов" value={fmt.num(regions.length)} sub={q?`по запросу «${search}»`:"с заказами"} color={P.teal}/>
            <KpiCard label="Топ-регион" value={regions[0]?.region||"—"} sub={regions[0]?`${fmt.num(regions[0].units)} шт`:""} color={P.accent}/>
            <KpiCard label="Доля топ-3" value={fmt.pct(regions.slice(0,3).reduce((s,r)=>s+r.units,0)/totalUnits*100)} sub="от всех штук" color={P.yellow}/>
          </div>
          <div className="m-stack" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,alignItems:"start"}}>
            <div className="tw">
              <table>
                <thead><tr><th>Регион</th><th className="r">Заказы</th><th className="r">Штук</th><th className="r">Выручка</th><th>Города</th></tr></thead>
                <tbody>
                  {regions.slice(0,60).map(r=>(
                    <tr key={r.region} onClick={()=>setSelRegion(s=>s===r.region?null:r.region)}
                        style={{cursor:"pointer",background:selRegion===r.region?P.accentSoft:"transparent"}}>
                      <td>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          <div style={{width:Math.max(3,r.units/(regions[0]?.units||1)*60),height:6,background:P.accent,borderRadius:3,flexShrink:0}}/>
                          <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:160}}>{r.region}</span>
                        </div>
                      </td>
                      <td className="r">{fmt.num(r.orders)}</td>
                      <td className="r">{fmt.num(r.units)}</td>
                      <td className="r">{fmt.rub(r.revenue)}</td>
                      <td style={{color:P.muted,fontSize:12,maxWidth:150,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.top_cities||"—"}</td>
                    </tr>
                  ))}
                  {!regions.length&&<tr><td colSpan={5}><div className="empty">Нет данных</div></td></tr>}
                </tbody>
              </table>
            </div>
            <div className="tw">
              <div style={{padding:"10px 12px",color:P.muted,fontSize:13,fontWeight:600}}>
                {selRegion?`Товары: ${selRegion}`:"Товары (все регионы)"}
                {selRegion&&<span style={{marginLeft:8,color:P.accent,cursor:"pointer"}} onClick={()=>setSelRegion(null)}>× сбросить</span>}
              </div>
              <table>
                <thead><tr><th>Артикул</th><th>Товар</th><th className="r">Заказы</th><th className="r">Штук</th><th className="r">Выручка</th></tr></thead>
                <tbody>
                  {skuRows.map(r=>(
                    <tr key={r.offer_id}>
                      <td style={{color:P.muted,fontSize:12}}>{r.offer_id}</td>
                      <td style={{maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.name||"—"}</td>
                      <td className="r">{fmt.num(r.orders)}</td>
                      <td className="r">{fmt.num(r.units)}</td>
                      <td className="r">{fmt.rub(r.revenue)}</td>
                    </tr>
                  ))}
                  {!skuRows.length&&<tr><td colSpan={5}><div className="empty">Нет данных</div></td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

// ── Login ────────────────────────────────────────────────────────────────────
function Login({onOk}){
  const [mode,setMode]=useState("login");
  const [email,setEmail]=useState("");
  const [pass,setPass]=useState("");
  const [err,setErr]=useState("");
  const [busy,setBusy]=useState(false);

  const submit=async()=>{
    setBusy(true);setErr("");
    try{
      const r=await fetch(`/api/auth/${mode}`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email,password:pass})});
      const d=await r.json().catch(()=>({detail:`HTTP ${r.status}`}));
      if(!r.ok)throw new Error(d.detail||"Ошибка");
      localStorage.setItem("token",d.token);
      onOk(d.email);
    }catch(e){setErr(e.message);}
    finally{setBusy(false);}
  };

  return(
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:P.bg,padding:16}}>
      <div className="card" style={{width:"100%",maxWidth:360,padding:28}}>
        <div className="header-logo" style={{marginBottom:6}}>Ozon<span>Analytics</span></div>
        <div style={{color:P.muted,fontSize:13,marginBottom:20}}>{mode==="login"?"Вход в аккаунт":"Регистрация"}</div>
        <input className="si" style={{width:"100%",marginBottom:10}} placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)}/>
        <input className="si" style={{width:"100%",marginBottom:14}} type="password" placeholder="Пароль (мин. 8 символов)" value={pass} onChange={e=>setPass(e.target.value)} onKeyDown={e=>e.key==="Enter"&&submit()}/>
        {err&&<div className="alert alert-e" style={{marginBottom:12}}>{err}</div>}
        <button className="btn" style={{width:"100%",background:P.accent,color:"#fff",padding:"10px 0",fontWeight:700}} disabled={busy} onClick={submit}>
          {busy?"...":mode==="login"?"Войти":"Создать аккаунт"}
        </button>
        <div style={{marginTop:14,fontSize:13,color:P.muted,textAlign:"center",cursor:"pointer"}}
             onClick={()=>{setMode(m=>m==="login"?"register":"login");setErr("");}}>
          {mode==="login"?"Нет аккаунта? Зарегистрироваться":"Уже есть аккаунт? Войти"}
        </div>
      </div>
    </div>
  );
}

// ── Diagnostics ──────────────────────────────────────────────────────────────
function Diagnostics(){
  const [period,setPeriod]=useState(28);
  const [filter,setFilter]=useState("all");
  const [search,setSearch]=useState("");
  const [syncing,setSyncing]=useState(false);
  const [syncMsg,setSyncMsg]=useState("");
  const {data,loading,error,reload}=useFetch(`/api/diagnostics/?days=${period}`,[period]);

  const doSync=async(d)=>{
    setSyncing(true);setSyncMsg("Выгрузка воронки из Ozon, может занять пару минут...");
    try{
      const r=await fetch(`/api/diagnostics/sync?days=${d}`,{method:"POST"});
      const j=await r.json().catch(()=>({detail:`HTTP ${r.status}`}));
      if(!r.ok)throw new Error(j.detail||"Ошибка синхронизации");
      setSyncMsg(`Готово: ${j.saved_rows} строк за период ${j.period}`);
      reload();
    }catch(e){setSyncMsg("Ошибка: "+e.message);}
    finally{setSyncing(false);}
  };

  const GROUPS={ok:{label:"Здоровые",color:P.teal,bg:P.tealSoft},warn:{label:"Проблема конверсии",color:P.yellow,bg:P.yellowSoft},dead:{label:"Нет трафика",color:P.red,bg:P.redSoft}};
  const items=(data?.items||[]).filter(r=>
    (filter==="all"||r.group===filter)&&
    (!search||r.name.toLowerCase().includes(search.toLowerCase())||String(r.sku).includes(search)||(r.offer_id||"").toLowerCase().includes(search.toLowerCase())));

  const exportCsv=()=>{
    const head="SKU;Товар;Показы;В корзину;Заказы;Выручка;Показ→Корзина %;Корзина→Заказ %;Проблема;Рекомендация";
    const lines=items.map(r=>[r.sku,`"${r.name}"`,r.views,r.tocart,r.orders,r.revenue,r.conv_cart,r.conv_order,`"${r.problem}"`,`"${r.advice}"`].join(";"));
    const blob=new Blob(["\ufeff"+[head,...lines].join("\n")],{type:"text/csv;charset=utf-8"});
    const a=document.createElement("a");a.href=URL.createObjectURL(blob);a.download=`diagnostika_${period}d.csv`;a.click();
  };

  return(
    <div>
      <div className="toolbar">
        <div className="pills">
          {[14,28,60,90].map(d=><button key={d} className={`pill ${period===d?"active":""}`} onClick={()=>setPeriod(d)}>{d}д</button>)}
        </div>
        <input className="si" placeholder="Поиск..." value={search} onChange={e=>setSearch(e.target.value)}/>
        <div style={{flex:1}}/>
        <button className="btn btn-g" disabled={syncing} onClick={()=>doSync(period)}>{syncing?"...":"⟳ Синхронизировать"}</button>
        <button className="btn btn-g" onClick={exportCsv}>⇩ CSV</button>
        <button className="btn btn-g" onClick={reload}>↺</button>
      </div>
      {syncMsg&&<div className="alert" style={{borderColor:P.accent,color:P.text,background:P.accentSoft,padding:"8px 12px",borderRadius:8,marginBottom:12}}>{syncMsg}</div>}
      {error&&<div className="alert alert-e">Ошибка: {error}</div>}
      {!loading&&data&&data.first_date&&(
        <div style={{color:P.muted,fontSize:12,marginBottom:10}}>
          Данные в базе: {data.first_date} — {data.last_date}. Если выбранный период больше этого диапазона, нажми «Синхронизировать».
        </div>
      )}
      {!loading&&data&&!(data.items||[]).length&&(
        <div className="card" style={{padding:20,marginBottom:14,textAlign:"center",color:P.muted}}>
          Данных воронки за период нет. Нажми «Синхронизировать» — при первом запуске выгрузится воронка за выбранный период (лучше выбрать 90д).
        </div>
      )}
      {loading?<Spin/>:data&&(
        <>
          <div className="grid grid-4" style={{marginBottom:14}}>
            <KpiCard label="Всего товаров" value={fmt.num(data.total)} sub={`за ${data.days} дней`} onClick={()=>setFilter("all")}/>
            <KpiCard label="Здоровые" value={fmt.num(data.ok)} sub={`медиана корзина→заказ ${data.median_conv_order}%`} color={P.teal} onClick={()=>setFilter("ok")}/>
            <KpiCard label="Проблема конверсии" value={fmt.num(data.warn)} sub="трафик есть, продаж мало" color={P.yellow} onClick={()=>setFilter("warn")}/>
            <KpiCard label="Нет трафика" value={fmt.num(data.dead)} sub="карточек нет в выдаче" color={P.red} onClick={()=>setFilter("dead")}/>
          </div>
          <div className="tw">
            <table>
              <thead><tr>
                <th>Товар</th><th>SKU</th><th className="r">Показы</th><th className="r">Корзина</th><th className="r">Заказы</th>
                <th className="r">Выручка</th><th className="r">П→К %</th><th className="r">К→З %</th><th>Диагноз</th>
              </tr></thead>
              <tbody>
                {items.map(r=>{
                  const g=GROUPS[r.group];
                  return(
                    <tr key={r.sku} title={r.advice}>
                      <td style={{maxWidth:280,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.name||r.sku}</td>
                      <td style={{color:P.muted,fontSize:12}}>{r.sku||"—"}</td>
                      <td className="r">{fmt.short(r.views)}</td>
                      <td className="r">{fmt.short(r.tocart)}</td>
                      <td className="r">{fmt.num(r.orders)}</td>
                      <td className="r">{fmt.rub(r.revenue)}</td>
                      <td className="r">{r.conv_cart}%</td>
                      <td className="r">{r.conv_order}%</td>
                      <td><span style={{background:g.bg,color:g.color,padding:"3px 8px",borderRadius:6,fontSize:12,fontWeight:600}}>{r.problem}</span></td>
                    </tr>
                  );
                })}
                {!items.length&&<tr><td colSpan={9}><div className="empty">Ничего не найдено</div></td></tr>}
              </tbody>
            </table>
          </div>
          <div style={{color:P.muted,fontSize:12,marginTop:10}}>
            Наведи на строку — увидишь рекомендацию. Пороги: относительно медиан магазина (П→К {data.median_conv_cart}%, К→З {data.median_conv_order}%).
          </div>
        </>
      )}
    </div>
  );
}

// Ошибка в одном разделе не должна давать белый экран всего сайта
class SectionBoundary extends React.Component{
  constructor(p){super(p);this.state={err:null};}
  static getDerivedStateFromError(err){return {err};}
  componentDidCatch(err,info){console.error("Раздел упал:",err,info);}
  render(){
    if(this.state.err)return(
      <div className="alert alert-e" style={{margin:20}}>
        Раздел не смог отобразиться: {String(this.state.err.message||this.state.err)}.
        Сообщите администратору. <button className="btn btn-g" onClick={()=>this.setState({err:null})}>Повторить</button>
      </div>
    );
    return this.props.children;
  }
}

// ── App ────────────────────────────────────────────────────────────────────
export default function App(){
  const [tab,setTab]=useState("dashboard");
  const navRef=useRef(null);
  useEffect(()=>{   // на телефоне меню прокручивается — держим активную вкладку на виду
    const el=navRef.current&&navRef.current.querySelector(".nav-tab.active");
    if(el&&el.scrollIntoView)try{el.scrollIntoView({block:"nearest",inline:"center"});}catch(_){}
  },[tab]);
  const [authed,setAuthed]=useState(!!localStorage.getItem("token"));
  const [me,setMe]=useState(null);
  const [stores,setStores]=useState(null);
  const [storeId,setStoreIdState]=useState(()=>Number(localStorage.getItem("storeId"))||null);

  const setStoreId=useCallback(id=>{
    if(id)localStorage.setItem("storeId",String(id));else localStorage.removeItem("storeId");
    setStoreIdState(id||null);
  },[]);

  useEffect(()=>{
    const handle=()=>{setAuthed(false);setMe(null);setStores(null);};
    window.addEventListener("ozon:logout",handle);
    return ()=>window.removeEventListener("ozon:logout",handle);
  },[]);

  // Магазины пользователя: выбранный, если он ещё есть, иначе первый
  const onStores=useCallback(list=>{
    setStores(list);
    const saved=Number(localStorage.getItem("storeId"));
    if(!list.length){setStoreId(null);return;}
    if(!list.some(s=>s.id===saved))setStoreId(list[0].id);
  },[setStoreId]);

  useEffect(()=>{
    if(!authed)return;
    fetch(API+"/api/auth/me").then(r=>r.ok?r.json():null).then(setMe).catch(()=>{});
    fetch(API+"/api/settings/stores").then(r=>r.json()).then(d=>{if(Array.isArray(d))onStores(d);}).catch(()=>{});
  },[authed,onStores]);

  if(!authed)return(<><style>{css}</style><Login onOk={()=>{setAuthed(true);}}/></>);

  const noStores=stores!==null&&stores.length===0;
  const isAdmin=!!(me&&me.is_admin);
  const tabs=[
    {id:"dashboard",label:"Дашборд",icon:"◈"},
    {id:"orders",label:"Заказы",icon:"⚡"},
    {id:"finance",label:"Финансы",icon:"₽"},
    {id:"sales",label:"Продажи",icon:"≡"},
    {id:"unit_economics",label:"Юнит-экономика",icon:"◑"},
    {id:"analytics",label:"Аналитика",icon:"◉"},
    {id:"diagnostics",label:"Диагностика",icon:"✦"},
    {id:"geo",label:"География",icon:"◉"},
    {id:"supply",label:"Поставки",icon:"⇪"},
    {id:"stocks",label:"Остатки",icon:"▦"},
    {id:"products",label:"Товары",icon:"◫"},
    {id:"settings",label:noStores?"Подключить магазин":"Магазины",icon:"◎"},
    ...(isAdmin?[
      {id:"admin",label:"Админ",icon:"⚙"},
      {id:"report",label:"Сводка",icon:"☰",href:"/report"},
    ]:[]),
  ];
  const curTab=noStores&&tab!=="admin"?"settings":tab;
  const pickTab=id=>{setTab(id);try{window.scrollTo(0,0);}catch(_){}};
  const logout=()=>{localStorage.removeItem("token");localStorage.removeItem("storeId");setAuthed(false);setMe(null);setStores(null);};
  const now=new Date().toLocaleString("ru-RU",{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"});

  return(
    <>
      <style>{css}</style>
      <div className="app">
        <header className="header">
          <div className="header-logo">Ozon<span>Analytics</span></div>
          {stores&&stores.length>0&&(
            <select className="store-selector" value={storeId||""} onChange={e=>setStoreId(Number(e.target.value))} title="Магазин">
              {stores.map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          )}
          <div className="header-spacer"/>
          {me&&<span className="m-hide" style={{fontSize:12,color:P.muted,marginRight:10}}>{me.email}</span>}
          <div className="header-time m-hide"><div className="sync-dot"/><span>{now}</span></div>
          <button className="btn btn-g" style={{marginLeft:10}} title="Выйти" onClick={logout}>⎋</button>
        </header>
        <nav className="nav" ref={navRef}>
          {tabs.map(t=>t.href?(
            <a key={t.id} className="nav-tab" href={t.href} style={{textDecoration:"none"}}><span>{t.icon}</span>{t.label}</a>
          ):(
            <button key={t.id} className={`nav-tab ${curTab===t.id?"active":""}`} onClick={()=>pickTab(t.id)} disabled={noStores&&t.id!=="settings"&&t.id!=="admin"}>
              <span>{t.icon}</span>{t.label}
            </button>
          ))}
        </nav>
        {/* key=storeId: при смене магазина все разделы перезагружают данные */}
        <main className="main" key={storeId||"none"}>
          <SectionBoundary key={curTab}>
          {curTab==="dashboard"&&<Dashboard storeId={storeId}/>}
          {curTab==="orders"&&<Orders/>}
          {curTab==="finance"&&<Finance/>}
          {curTab==="sales"&&<Sales/>}
          {curTab==="unit_economics"&&<UnitEconomics/>}
          {curTab==="analytics"&&<Analytics/>}
          {curTab==="diagnostics"&&<Diagnostics/>}
          {curTab==="geo"&&<Geography/>}
          {curTab==="supply"&&<Supply/>}
          {curTab==="stocks"&&<Stocks/>}
          {curTab==="products"&&<Products/>}
          {curTab==="settings"&&<Settings currentId={storeId} onStores={onStores} onSelect={id=>{setStoreId(id);setTab("dashboard");}}/>}
          {curTab==="admin"&&isAdmin&&<Admin/>}
          </SectionBoundary>
        </main>
      </div>
    </>
  );
}
